var customer_id = __st.cid;
var today = new Date(new Date().toLocaleString("en-US", {timeZone: "America/Los_Angeles"}));
var oldcountrycookies = getCookie("usercountry");
document.addEventListener('DOMContentLoaded', checkcountry);

function hidebuttonbycountry(countryname){
  //alert(countryname);
    var eucountrylist = ["Albania", "Andorra", "Austria", "Belarus", "Belgium", "Bosnia & Herzegovina", "Bulgaria", "Croatia", "Cyprus", "Czechia", "Denmark", "Estonia", "Faroe Islands", "Finland", "France", "Germany", "Gibraltar", "Greece", "Guernsey", "Hungary", "Iceland", "Ireland", "Isle of Man", "Italy", "Jersey", "Kosovo", "Latvia", "Liechtenstein", "Lithuania", "Luxembourg", "Malta", "Moldova", "Monaco", "Montenegro", "Netherlands", "North Macedonia", "Norway", "Poland", "Portugal", "Romania", "Russia", "San Marino", "Serbia", "Slovakia", "Slovenia", "Spain", "Svalbard & Jan Mayen", "Sweden", "Switzerland", "Ukraine", "United Kingdom", "Vatican City"];
    if(countryname == 'Mexico'){
      var crpurchaselink = 'https://sephora.com.mx/categories/marcas/truly-beauty';
      var crpurchasetext = 'Sephora';
      var buttoncountryname = 'Mexico';
    }else if(eucountrylist.includes(countryname)){
     // alert(countryname);
      var crpurchaselink = 'https://www.boots.com/truly-beauty';
      var crpurchasetext = 'Boots';  
      var buttoncountryname = 'United Kingdom';
      $('.cookiespolicy-containar').addClass('d-none');
    }
    
   if($('.add-to-cart-ajax').hasClass('hellovs')){
      $('.add-to-cart-ajax').removeClass('hellovs');
    }
   if($('a').hasClass('addToCart')){
      $('a.addToCart').attr("href", crpurchaselink).attr("target", "_blank").html('Buy at '+crpurchasetext+'').removeClass('addToCart');
    }
   if($('a').hasClass('bundle_btn')){
      $('a.bundle_btn').attr("href", crpurchaselink).attr("target", "_blank").html('Buy at '+crpurchasetext+'').removeClass('bundle_btn');
    }
    $('.Shopify-product-form').addClass('d-none');
    $('.'+buttoncountryname.toLowerCase().replace(/\s/g, '')+'-atc-button').removeClass('d-none');
    $('.byo_bundleHead p, .text_head h5, .bd_text_head h5').html('Not available in '+buttoncountryname+'. <a target="_blank" style="text-decoration: underline;" href="'+crpurchaselink+'">Check out Truly products at '+crpurchasetext+'</a>');
    $('.byo_progressBar, .byo_searchForm, .allproducts, .byo_stickyWrap').addClass('d-none').addClass('hide');
    $('.pack__cartItems, .sticky_sec,  #pre-shave-lander, .bd_text_head p, .bd_progressBar').addClass('d-none'); //form,
    $('.quizapp_section').addClass('text-align-center').css('align-content','center').html('').html('<h4>Not available in '+buttoncountryname+'. <a target="_blank" style="text-decoration: underline;" href="'+crpurchaselink+'">Check out Truly products at '+crpurchasetext+'</a></h4>');
   $('form.product-form__bundle').addClass('d-none').after('<p class="mb-5">Not available in '+buttoncountryname+'. <a target="_blank" style="text-decoration: underline;" href="'+crpurchaselink+'">Check out Truly products at '+crpurchasetext+'</a></p>');
   $('form.navigationproductsection button').removeClass('add-to-cart-ajax').removeAttr("type").attr("type","button").attr("onclick", "window.open('"+crpurchaselink+"', '_blank');");
   $('.preshavebanner span').html('Not Available in '+buttoncountryname+'');
   //$('.hm_shop_now_btn-truly-beauty-advent-calendar').attr("href", crpurchaselink).attr("target", "_blank").html('Buy at '+crpurchasetext+'');
}

function checkcountry(){
var country ='';
var countrylist = ["Mexico","Albania", "Andorra", "Austria", "Belarus", "Belgium", "Bosnia & Herzegovina", "Bulgaria", "Croatia", "Cyprus", "Czechia", "Denmark", "Estonia", "Faroe Islands", "Finland", "France", "Germany", "Gibraltar", "Greece", "Guernsey", "Hungary", "Iceland", "Ireland", "Isle of Man", "Italy", "Jersey", "Kosovo", "Latvia", "Liechtenstein", "Lithuania", "Luxembourg", "Malta", "Moldova", "Monaco", "Montenegro", "Netherlands", "North Macedonia", "Norway", "Poland", "Portugal", "Romania", "Russia", "San Marino", "Serbia", "Slovakia", "Slovenia", "Spain", "Svalbard & Jan Mayen", "Sweden", "Switzerland", "Ukraine", "United Kingdom", "Vatican City"];
if (oldcountrycookies === undefined  || oldcountrycookies === null) {
  fetch('/browsing_context_suggestions.json')
  .then(response => {
  return response.json();
})
  .then((json) => {
    country = json.detected_values.country.name; 
    var date = new Date();
  date.setTime(date.getTime() + (10 * 60 * 1000));
  document.cookie = "usercountry="+country+"; expires=" + date.toGMTString() + "; path=/";
    if(countrylist.includes(country)){
      $('body').addClass('countryblock');
       hidebuttonbycountry(country);
    }
    
  });
}else{
  if(countrylist.includes(oldcountrycookies)){
      $('body').addClass('countryblock');
       hidebuttonbycountry(oldcountrycookies);
    }
     
    
}
}
// today.toLocaleString();
//  mystrytoday = String(today.getMonth() + 1).padStart(2, '0') + '/' + String(today.getDate()).padStart(2, '0') + '/' + today.getFullYear();
// if(mystrytoday=='10/29/2025' || mystrytoday=='10/30/2025' || mystrytoday=='10/31/2025' || mystrytoday=='11/01/2025' || mystrytoday=='11/02/2025' || mystrytoday=='11/03/2025' || mystrytoday=='11/04/2025' || mystrytoday=='11/05/2025'){
//   mysterybagvariantid = '40979432079395';
//   mysterybagproductid = '7154241208355';
// }else if(mystrytoday=='11/06/2025' || mystrytoday=='11/07/2025' || mystrytoday=='11/08/2025' || mystrytoday=='11/09/2025' || mystrytoday=='11/10/2025' || mystrytoday=='11/11/2025' || mystrytoday=='11/12/2025'){
//   mysterybagvariantid = '40979432341539';
//   mysterybagproductid = '7154241470499';
// }else if(mystrytoday=='11/13/2025' || mystrytoday=='11/14/2025' || mystrytoday=='11/15/2025' || mystrytoday=='11/16/2025' || mystrytoday=='11/17/2025' || mystrytoday=='11/18/2025' || mystrytoday=='11/19/2025'){
//   mysterybagvariantid = '40979432439843';
//   mysterybagproductid = '7154241568803';
// }else if(mystrytoday=='11/20/2025' || mystrytoday=='11/21/2025' || mystrytoday=='11/22/2025' || mystrytoday=='11/23/2025' || mystrytoday=='11/24/2025' || mystrytoday=='11/25/2025'){
//   mysterybagvariantid = '40979432505379';
//   mysterybagproductid = '7154241634339';
// }else if(mystrytoday=='11/26/2025'){
//   if(getCookie("istrulyplusmember") == "yes"){
//     mysterybagvariantid = '40979432570915';
//     mysterybagproductid = '7154241699875';
//     rmmysterybagvariantid = '40979432505379';
//   }else{
//     mysterybagvariantid = '40979432505379';
//     mysterybagproductid = '7154241634339';
//     rmmysterybagvariantid = '40979432570915';
//   }  
// }else if(mystrytoday=='11/27/2025'){
//   mysterybagvariantid = '40979432701987';
//   mysterybagproductid = '7154241896483';
// }else if(mystrytoday=='11/28/2025'){
//   mysterybagvariantid = '40979432767523';
//   mysterybagproductid = '7154241962019';
// }else if(mystrytoday=='11/29/2025'){
//   mysterybagvariantid = '40979433291811';
//   mysterybagproductid = '7154242322467';
// }else if(mystrytoday=='11/30/2025'){
//   mysterybagvariantid = '40979433848867';
//   mysterybagproductid = '7154242584611';
// }else if(mystrytoday=='12/01/2025' ){
//   mysterybagvariantid = '40979434438691';
//   mysterybagproductid = '7154242846755';
// }else if(mystrytoday=='12/02/2025'){
//   mysterybagvariantid = '40979434864675';
//   mysterybagproductid = '7154243108899';
// }else{
//     mysterybagvariantid = '40979432079395';
//     mysterybagproductid = '7154241208355';
  
// }
    // mysterybagpprice = 150;
    // mysterybagprice = 15000; 
    santahatpprice = 75;
    santahatprice = 7500;
    santahatvariantid = '39638423207971';
    santahatproductid = '6671759474723';

/** lazyload images ***/

document.addEventListener("DOMContentLoaded", function () {
  var lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));
  //console.log('lazy');
  if ("IntersectionObserver" in window) {
    let lazyImageObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          let lazyImage = entry.target;
          lazyImage.src = lazyImage.dataset.src;
          //  lazyImage.srcset = lazyImage.dataset.srcset;
          lazyImage.classList.remove("lazy");
          lazyImageObserver.unobserve(lazyImage);
        }
      });
    });

    lazyImages.forEach(function (lazyImage) {
      lazyImageObserver.observe(lazyImage);
    });
  } else {
    // Possibly fall back to event handlers here
  }
});


const urlParams = new URLSearchParams(window.location.search);
/**check paid trafic and set cookies start**/
var paidtraficcheck = urlParams.get("tr");
if (paidtraficcheck != null) {
  var date = new Date();
  date.setTime(date.getTime() + 24 * 60 * 60 * 1000);
}
/**check paid trafic and set cookies start**/

/**check Email Only Mystery Bag Offer utm_campaign and set cookies start **/
//   var utm_campaigncheck = urlParams.get("utm_campaign");
//   var utm_sourcecheck = urlParams.get("utm_source");
// if (utm_campaigncheck != null && utm_sourcecheck != null) {
//   if(utm_sourcecheck == 'email-klaviyo' && (utm_campaigncheck.includes('BOGO PP E4: Mystery bag') || utm_campaigncheck.includes('BOGO PP E4: Mystery Bag'))){
//     var date = new Date();
//     date.setTime(date.getTime() + 30 * 60 * 1000);
//     document.cookie = "utm_emailcampaigncookies=enable; expires=" + date.toGMTString() + "; path=/";
//   }
// }
/**check utm_campaign and set cookies start**/

/*** Currency Helpers ***/
var theme = theme || {};
//console.log("theme",theme);
theme.Currency = (function () {
  var moneyFormat = "${{amount}}"; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ",";
      decimal = decimal || ".";

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split(".");
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      );
       var centsAmount = parts[1] && parseInt(parts[1]) > 0 ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");

        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney,
  };
})();

/*Social login code start*/
//alert(customer_id);
  if(typeof customer_id == "undefined"){
  //console.log("customer_logout")
  var googleUser = {};
  var startApp = function () {
    gapi.load("auth2", function () {
      // Retrieve the singleton for the GoogleAuth library and set up the client.
      auth2 = gapi.auth2.init({
        client_id:
          "609340619388-t94f25gqjmgnqpldeed6v8o331p47rvq.apps.googleusercontent.com",
        cookiepolicy: "single_host_origin",
        // Request scopes in addition to 'profile' and 'email'
        //scope: 'additional_scope'
      });
      attachSignin(document.getElementById("customBtn"));
    });
  };

  function attachSignin(element) {
    auth2.attachClickHandler(
      element,
      {},
      function (googleUser) {
        var profile = googleUser.getBasicProfile();
        fulname = profile.getName();
        nameArry = fulname.split(" ");
        $(".loaderspinmain").css("display", "flex");
        $.ajax({
          url: "https://mytrulydeals.com/trulybeauty/social_login.php",
          type: "POST",
          data: {
            ajaxaction: "socialsignuplogin",
            customer_email: profile.getEmail(),
            social_name: "google",
            customer_name: profile.getName(),
            customer_firstname: nameArry[0],
            customer_lastname: nameArry[0],
            customer_socialid: profile.getId(),
          },
          async: true,
          success: function (data) {
            var objJSON = JSON.parse(data);
            if (objJSON.error) {
              var errordiv =
                '<div class="form-message form-message--error"><h2 class="h3 form-message__title " data-form-status="">Please adjust the following:</h2><div class="errors"><ul><li>' +
                objJSON.error +
                "</li></ul></div></div>";
              //$(errordiv).insertBefore("#status");
              $("#status").html(errordiv);
              $(".loaderspinmain").css("display", "none");
              setTimeout(function () {
                $("#status").html("");
              }, 3000);
            } else {
              var auth2 = gapi.auth2.getAuthInstance();
              auth2.signOut().then(function () {});
              var form = document.getElementById("customer_login");
              document.getElementById("customer_email").value =
                objJSON.customer_email;
              document.getElementById("customer_password").value =
                objJSON.customer_password;
              form.submit();
            }
          },
          timeout: 5000000, // sets timeout to 5 seconds
        });
      },
      function (error) {
        //alert(JSON.stringify(error, undefined, 2));
      }
    );
  }
  startApp();

  // Initialize the Facebook JavaScript SDK, but wait till it's loaded
      window.fbAsyncInit = function () {
        FB.init({
          appId: "808767840695234",
          xfbml: true,
          version: "v17.0",
        });
      };

      // Handle clicks on the "Log in with Facebook" button
      function loginWithFacebook() {
        FB.login(function (response) {
          if (response.authResponse) {
            console.log("Welcome!  Fetching your information.... ");
            // After successful login, we can fetch the user's information
            FB.api("/me", { fields: "name, email, id, first_name, last_name" }, function (response) {

                $(".loaderspinmain").css("display", "flex");
                $.ajax({
                    url: "https://mytrulydeals.com/trulybeauty/social_login.php",
                    type: "POST",
                    data: {
                        ajaxaction: "socialsignuplogin",
                        customer_email: response.email,
                        social_name: "facebook",
                        customer_name: response.name,
                        customer_firstname: response.first_name,
                        customer_lastname: response.last_name,
                        customer_socialid: response.id,
                    },
                    async: true,
                    success: function (data) {
                        var objJSON = JSON.parse(data);
                        if (objJSON.error) {
                        var errordiv =
                            '<div class="form-message form-message--error"><h2 class="h3 form-message__title " data-form-status="">Please adjust the following:</h2><div class="errors"><ul><li>' +
                            objJSON.error +
                            "</li></ul></div></div>";

                        $("#status").html(errordiv);
                        $(".loaderspinmain").css("display", "none");
                        setTimeout(function () {
                            $("#status").html("");
                        }, 3000);
                        } else {
                        var form = document.getElementById("customer_login");
                        document.getElementById("customer_email").value =
                            objJSON.customer_email;
                        document.getElementById("customer_password").value =
                            objJSON.customer_password;
                        form.submit();
                        }
                    },
                    timeout: 5000000, // sets timeout to 5 seconds
                    });
                });
          } else {
            console.log("User cancelled login or did not fully authorize.");
          }
        });
      }

      // Load the JavaScript SDK asynchronously
      (function (d, s, id) {
        var js,
          fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
          return;
        }
        js = d.createElement(s);
        js.id = id;
        js.src = "https://connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
      })(document, "script", "facebook-jssdk");
}
/*Social login code end */

/* button add to cart */
$(document).on("click", ".add-to-cart-ajax", function (e) {
  // $('body').removeClass('showSearchModal').removeClass('showModal');
  // $('.trulySidebarModelOverlay').css('display','none');
  if (
    $(this).hasClass("GiftWizard-gift-button") &&
    $(this).hasClass("add-to-cart-ajax")
  ) {
    return;
  }
  e.preventDefault();
  var formID = $(this).closest("form").attr("id");
  var productid = $("#" + formID).attr("data-productid");
  var price = $("#" + formID)
    .find(".money")
    .text();
  var tprice = price.replace("$", "");
  
  var formData = new FormData($("#"+formID)[0]);
  
   var crntsellingoption = $('input[name="sellingplan_option"]:checked').val();
   if (crntsellingoption == "onetime" && $(this).not('.selingPlanmoney').length > 0) {
       formData.delete('selling_plan');
    } 
  //console.log('formData',formData);
  formdata = new URLSearchParams(formData).toString();
  //var formdata = $(this).closest("form").serialize();
  var currentproducthandle = $(this)
    .closest("form")
    .find('input[name="id"]')
    .attr("data-producthandle");

  var currentvariationid = $(this)
    .closest("form")
    .find('input[name="id"]')
    .val();
  if (typeof currentproducthandle === "undefined") {
    var currentproducthandle = $(this)
      .closest("form")
      .find('select[name="id"]')
      .attr("data-producthandle");
    var currentvariationid = $(this)
      .closest("form")
      .find('select[name="id"]')
      .val();
  }
  var currentdatalistname = $(this)
    .closest("form")
    .find('input[name="id"]')
    .attr("data-listname");
  var checksub = $(this)
    .closest("form")
    .find('input[name="sellingplan_option"]:checked')
    .val();
  addtocartproArray = [];
  if (typeof currentproducthandle !== "undefined") {
    $.ajax({
      dataType: "json",
      async: false,
      url:
        "https://www.trulybeauty.com/products/" + currentproducthandle + ".js",
      success: function (data) {
        for (var i = 0; i < data.variants.length; i++) {
          if (data.variants[i]["id"] == currentvariationid) {
            if (typeof checksub !== "undefined" && checksub == "subscription") {
              price = (
                data.variants[i].selling_plan_allocations[0][
                  "price_adjustments"
                ][0]["price"] / 100
              ).toFixed(2);
              sku = data.variants[i].sku;
              item_variant = data.variants[i].id;
              item_cat2 = "Subscribe & save 10 % Off";
            } else {
              price = (data.variants[i].price / 100).toFixed(2);
              sku = data.variants[i].sku;
              item_variant = data.variants[i].id;
              item_cat2 = "One-time purchase";
            }
          }
        }
        var addtocartitem = {
          item_id: data.id,
          item_name: data.title,
          currency: "USD",
          item_brand: data.vendor,
          item_category: data.type,
          item_category2: item_cat2,
          item_list_name: currentdatalistname,
          price: price,
          quantity: 1,
          item_variant: item_variant,
          imageURL: data.featured_image,
          productURL: "https://www.trulybeauty.com/products/" + data.handle,
          sku: sku,
        };
        addtocartproArray.push(addtocartitem);
      },
    });
    //console.log(addtocartproArray);
    dataLayer.push({ ecommerce: null });
    dataLayer.push({
      event: "add_to_cart",
      ecommerce: {
        items: addtocartproArray,
      },
    });
  }
  ajaxaddProductToCart(formdata);
});

function getCookie(name) {
  var dc = document.cookie;
  var prefix = name + "=";
  var begin = dc.indexOf("; " + prefix);
  if (begin == -1) {
    begin = dc.indexOf(prefix);
    if (begin != 0) return null;
  } else {
    begin += 2;
    var end = document.cookie.indexOf(";", begin);
    if (end == -1) {
      end = dc.length;
    }
  }
  return decodeURI(dc.substring(begin + prefix.length, end));
}
function rebuyupdatecart(){
  $.ajax({
  type: "GET",
  url: window.Shopify.routes.root+"cart.js",
  dataType: "json",
  async: true,
    success: function (cart) {
      
      applypromos(cart);
      getcart();
    }
  });
}
function getcart(){
  fetch(
    `/cart?section_id=main-cart-items`
  )
    .then((response) => {
      if (!response.ok) {
        var error = new Error(response.status);
        this.close();
        throw error;
      }
      return response.text();
    })
    .then((text) => {

      if(new DOMParser().parseFromString(text, "text/html").querySelector("#allcartitems") === null){
        location.reload();
      }else{
        
      
      const resultcartitems = new DOMParser()
        .parseFromString(text, "text/html")
        .querySelector("#allcartitems").innerHTML;
      $("#allcartitems").html(resultcartitems);

      const resultcartsubtotal = new DOMParser()
        .parseFromString(text, "text/html")
        .querySelector(".priceSubtotal span.money").innerHTML;
      $(".priceSubtotal span.money").html(resultcartsubtotal);

      const resultcarttotal = new DOMParser()
        .parseFromString(text, "text/html")
        .querySelector(".priceTotal span.money").innerHTML;
      $(".priceTotal span.money").html(resultcarttotal);
        if(new DOMParser()
        .parseFromString(text, "text/html")
        .querySelector(".saveTable_row") !== null){
          const resultmembersaving = new DOMParser()
        .parseFromString(text, "text/html")
        .querySelector(".saveTable_row").innerHTML;
        if ($('.saveTable_row').length) {
           $(".saveTable_row").html(resultmembersaving);  
        }else{
          $('<div class="saveTable_row">'+resultmembersaving+'</div>').insertAfter('.bt-top');
        }
        }else{
        $( ".saveTable_row" ).remove();
        }
      freeshippingbar(resultcarttotal.replace("$", ""));
        
      $.ajax({
            type: "GET",
            url: window.Shopify.routes.root+"cart.js",
            dataType: "json",
            async: true,
              success: function (cart) {
                 //blackfridaysale(cart);
                 //santahatsale(cart);
                vmproducts = {};
                checkserumkit = 0;
                removefreeproducts = {};
                cart.items.forEach(function (item, index) {
                  
                  $.each(item.properties, function (key, val) {
                    indexid = index+1;
                    if(key == '_free_with' && val == 'Serum Starter Kit'){
                      removefreeproducts[item.key]=0;
                    }
                  });
                  // if (cart.item_count == 1) {
                  //   if (item.product_id == mysterybagproductid ){
                  //     removefreeproducts[mysterybagvariantid]=0;
                  //   }
                  // }

                });
                
                if(cart.item_count == 1 && Object.keys(removefreeproducts).length >=1){
                  $.ajax({
                    type: "POST",
                    url: window.Shopify.routes.root+"cart/update.js",
                    data: { updates: removefreeproducts },
                    dataType: "json",
                    async:false,
                    success: function (data) {
                      location.reload();
                    }
                  });
                }
              }
          });
        }
    })
    .catch((error) => {
      throw error;
    });
}
$.ajax({
  type: "GET",
  url: window.Shopify.routes.root+"cart.js",
  dataType: "json",
  async: true,
    success: function (cart) {
      subproincart =0 ;
      checkoutitemsArray = [];
      cart_price = cart.total_price / 100;
  carttotal = cart_price.toFixed(2);
       var total_price = cart.total_price / 100;
var final_total_price = total_price.toFixed(2);
      cart.items.forEach(function (item, index) {
        if (typeof item.selling_plan_allocation !== "undefined") {
          itmcat2 = "Subscribe & save 10 % Off";
          subproincart = 1;
        } else {
          itmcat2 = "One-time purchase";
        }
        var checkoutitem = {
          item_id: item.product_id,
          item_name: item.product_title,
          currency: "USD",
          item_brand: item.vendor,
          item_category: item.product_type,
          item_category2: itmcat2,
          item_list_name: "Checkout Product",
          price: (item.price / 100).toFixed(2),
          quantity: item.quantity,
          item_variant: item.variant_id,
        };
        checkoutitemsArray.push(checkoutitem);
      });
      freeshippingbar(final_total_price);
      //blackfridaysale(cart);
      //santahatsale(cart);
     
    }
});

$(document).on("click", "#cartformsubmit", function () {
  document.cookie =
    "exclusiveofferminis=disable; expires=Thu, 18 Dec 2013 12:00:00 UTC; path=/";
  // document.cookie = 
  //   "utm_campaigncookies=disable; expires=Thu, 18 Dec 2013 12:00:00 UTC; path=/"
  dataLayer.push({ ecommerce: null });
  dataLayer.push({
    event: "begin_checkout",
    currency: "USD",
    value: carttotal,
    ecommerce: {
      items: checkoutitemsArray,
    },
  });
});

if ($("body").hasClass("template-cart")) {
 
  $.ajax({
    type: "GET",
    url: window.Shopify.routes.root+"cart.js",
    dataType: "json",
    success: function (cart) {
      if (cart.item_count >= 1) {
    
  applypromos(cart);
      getcart();
    
      }
    }
  });
}

/*** sidebar-cart **/
function ajaxaddProductToCart(formdata) {
  $.ajax({
    type: "POST",
    url: window.Shopify.routes.root+"cart/add.js",
    dataType: "json",
    data: formdata,
    success: ajaxaddToCartOk,
    error: ajaxaddToCartFail,
  });
}

function ajaxaddToCartOk(product) {

  if($("body").hasClass("template-glazed-donut-shave-set-v1") || $("body").hasClass("template-glazed-donut-shave-set-v2") || $("body").hasClass("template-smooth-legend-after-shave-serum")){
     window.location.href = `/checkout`;
  }else{
    showCartModal(product);
    if ($("body").hasClass("template-cart")) {
      getcart();
    }
  }
}

function ajaxaddToCartFail() {
  hideModal();
}

function ajaxfetchCart(product) {
    
  //console.log("ajaxfetchCart", product);
  $(".sidebar__cartItem").html(
    '<a href="https://www.trulybeauty.com/products/' +
      product.handle +
      '"><div class="cartItem__img pb-1"><img src="' +
      product.image +
      '" alt="cart-product" class="d-block"></div><div class="cartItem__title">' +
      product.product_title +
      "</div></a>"
  );
  if(typeof product.selling_plan_allocation !== "undefined"){
          var product_sellingplan = product.id+'_'+product.selling_plan_allocation.selling_plan.id;
        }else{
          var product_sellingplan = product.id+'_nil';
        }
   
  $.ajax({
    type: "GET",
    url: window.Shopify.routes.root+"cart.js",
    dataType: "json",
    success: function (cart) {

      if (cart.item_count === 0) {
          $(".special-offer--cartside").addClass("d-none");
        $(".headerCartItems").html("0").css('visibility','hidden');
      } else {
         $(".headerCartItems").html(Number(cart.item_count)).css('visibility','visible');
        ajaxrenderCart(cart, product.id,product_sellingplan);
       
        applypromos(cart);
      }
    },
  });
}


/*Apply all promos before checkout page start*/
function applypromos(cart) {
  // console.log('promofunction start');
  if (cart.item_count != 0) {
    vmproducts = {};
    checkgiftcardincart = 0;
   // checkmysterbagincart = 0;
    //checksantahatincart = 0;
    //checkemailmysterbagincart = 0;
    qtyInTheCart = 0;
    //checkfreebogomf = 0;
    exfrck = 0;
    checkfreeproductincart = 0;
    
    var minipagearray = new Array();

    cart.items.forEach(function (item, index) {
      
      /*check the gift card is in cart or not start */
      if (item.product_id == 4837186666531) {
        checkgiftcardincart = 1;
      }
      /* check the gift card is in cart or not start */

      /*check the mystery bag is in cart or not start */
      // if (item.product_id == mysterybagproductid ) {
      //   checkmysterbagincart = item.line_price;
      // }
      /* check the mystery bag is in cart or not end */

      /*check the email mystery bag is in cart or not start */
      // if (item.product_id == 7059712475171 ) {
      //   checkemailmysterbagincart = item.line_price;
      //   checkfreebogomf = 1;
      // }
      /* check the email mystery bag is in cart or not end */

      /*check santa hat is in cart or not start */
      // if (item.product_id == santahatproductid ) {
      //   checksantahatincart = item.line_price;
      // }
      /* check santa is in cart or not end */

      /*check free product in cart or not start */
      // if (item.variant_id == 42018762293283 ) {
      //   checkfreeproductincart = item.line_price;
      // }
      /* check free product in cart or not end */
    });
    
    /* Add free product to cart over $100 start */    
    // if(cart.original_total_price-checkfreeproductincart-cart.total_discount >=10000 ){
    //   //vmproducts[rmmysterybagvariantid]=0;
    //      if(checkgiftcardincart==1 ){
    //       // alert('gck');
    //         vmproducts[42018762293283]=0;
    //       }else{
    //         var freecartItems1 = '{{ cart.items | json }}',
    //             qtyInTheCart1 = 0,
    //              cartUpdates1 = {};
    //              for (var i=0; i<Object.keys(cart.items).length; i++) {
    //               if ( freecartItems1[i].id === 42018762293283) {
    //                 qtyInTheCart1 = freecartItems1[i].quantity;
    //               break;
    //                }
    //              }
    //          if ( ( Object.keys(cart.items).length === 1 ) && ( qtyInTheCart1 > 0 ) ) {
    //            vmproducts[42018762293283]=0;
    //             }
    //            else if ( ( Object.keys(cart.items).length >= 1 ) && ( qtyInTheCart1 !== 1 ) ) {
    //           vmproducts[42018762293283]=1;
    //             }
    //       }

    //              }else{
    //       vmproducts[42018762293283]=0;
          
    //              }
    
    
    /* Add free product to cart over $100 start */
    
  /* Add free mystery bag to cart over $150 start */    
    // if(cart.original_total_price-checkmysterbagincart-cart.total_discount >=mysterybagprice ){ //&& getCookie("istrulyplusmember") == "yes"
    //   //vmproducts[rmmysterybagvariantid]=0;
    //      if(checkgiftcardincart==1 ){
    //       // alert('gck');
    //         vmproducts[mysterybagvariantid]=0;
    //       }else{
    //         var freecartItems1 = '{{ cart.items | json }}',
    //             qtyInTheCart1 = 0,
    //              cartUpdates1 = {};
    //              for (var i=0; i<Object.keys(cart.items).length; i++) {
    //               if ( freecartItems1[i].id === mysterybagvariantid) {
    //                 qtyInTheCart1 = freecartItems1[i].quantity;
    //               break;
    //                }
    //              }
    //          if ( ( Object.keys(cart.items).length === 1 ) && ( qtyInTheCart1 > 0 ) ) {
    //            vmproducts[mysterybagvariantid]=0;
    //             }
    //            else if ( ( Object.keys(cart.items).length >= 1 ) && ( qtyInTheCart1 !== 1 ) ) {
    //           vmproducts[mysterybagvariantid]=1;
    //             }
    //       }

    //              }else{
    //       vmproducts[mysterybagvariantid]=0;
          
    //              }
    
    
    /* Add free mystery bag to cart over $150 start */

    /* Add email mysterybag to cart over $75 start */
//      if(typeof customer_id !== "undefined"){
       
// // alert(getCookie("emailmysbag_purshased"));
// //     alert(getCookie("utm_emailcampaigncookies"));
// if(cart.original_total_price-checkemailmysterbagincart-cart.total_discount >=7500 && getCookie("utm_emailcampaigncookies") == "enable" && getCookie("emailmysbag_purshased") == "no"){
 
//      if(checkgiftcardincart==1 ){
//       // alert('gck');
//         vmproducts[40615785857059]=0;
//       }else{
//         var freecartItems1 = '{{ cart.items | json }}',
//             qtyInTheCart1 = 0,
//              cartUpdates1 = {};
//              for (var i=0; i<Object.keys(cart.items).length; i++) {
//               if ( freecartItems1[i].id === 40615785857059) {
//                 qtyInTheCart1 = freecartItems1[i].quantity;
//               break;
//                }
//              }
//          if ( ( Object.keys(cart.items).length === 1 ) && ( qtyInTheCart1 > 0 ) ) {
//            vmproducts[40615785857059]=0;
//             }
//            else if ( ( Object.keys(cart.items).length >= 1 ) && ( qtyInTheCart1 !== 1 ) ) {
//           vmproducts[40615785857059]=1;
//             }
//       }
//              }else{
//                 if(checkfreebogomf == 1){
//                   vmproducts[40615785857059]=0;
//                 }
//              }
//      }else{
//                 if(checkfreebogomf == 1){
//                   vmproducts[40615785857059]=0;
//                 }
      
//              }
    
    /* Add email mysterybag to cart over $75 end */

    /* Add santa hat to cart over $75 start */

    // if(cart.original_total_price-checksantahatincart-cart.total_discount >=santahatprice ){
     
    //      if(checkgiftcardincart==1 ){
    //       // alert('gck');
    //         vmproducts[santahatvariantid]=0;
    //       }else{
    //         var freecartItems1 = '{{ cart.items | json }}',
    //             qtyInTheCart1 = 0,
    //              cartUpdates1 = {};
    //              for (var i=0; i<Object.keys(cart.items).length; i++) {
    //               if ( freecartItems1[i].id === santahatvariantid) {
    //                 qtyInTheCart1 = freecartItems1[i].quantity;
    //               break;
    //                }
    //              }
    //          if ( ( Object.keys(cart.items).length === 1 ) && ( qtyInTheCart1 > 0 ) ) {
    //            vmproducts[santahatvariantid]=0;
    //             }
    //            else if ( ( Object.keys(cart.items).length >= 1 ) && ( qtyInTheCart1 !== 1 ) ) {
    //           vmproducts[santahatvariantid]=1;
    //             }
    //       }

    //              }else{
    //       vmproducts[santahatvariantid]=0;
    //              }
    
    /* Add santa hat to cart over $75 start */
    
    $.ajax({
      type: "POST",
      url: window.Shopify.routes.root+"cart/update.js",
      data: { updates: vmproducts },
      dataType: "json",
      async:false,
      success: function (data) {
        if (data.item_count === 0) {
          $(".special-offer--cartside").addClass("hide"); //--special-offer
          $(".headerCartItems").html("0").css('visibility','hidden');
          //hideModal();
          $(".cartEmpty").removeClass("d-none");
          $(".cartNotEmpty").addClass("d-none");
          $(".also-like").addClass("d-none");
        } else {
           var total_price = data.total_price / 100;
           var final_total_price = total_price.toFixed(2);
           freeshippingbar(final_total_price);
           
          $(".headerCartItems").html(Number(cart.item_count)).css('visibility','visible');

          $(".cartEmpty").addClass("d-none");
          $(".cartNotEmpty").removeClass("d-none");
          $(".also-like").removeClass("d-none");
        }
        if (
          $("body").hasClass("template-smooth-legend-2") ||
          $("body").hasClass("template-the-best-gift-of-the-year-1") ||
          $("body").hasClass("template-fixed-my-red-bumpy-skin-1")
        ) {
          window.location.href = "https://www.trulybeauty.com/checkout";
        }
        if ($("body").hasClass("template-cart")) {
          //alert(getCookie('exclusiveofferminis')); alert(exfrck);
          if (exfrck == 1) {
            getcart();
          }
        } 
      },
    });
  }
}

/*Apply all promos before checkout page end*/


function imgURL(src, size) {
  // remove any current image size then add the new image size
  if (src) {
    return src
      .replace(
        /_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master|medium_crop_center)+\./g,
        "."
      )
      .replace(/\.jpg|\.png|\.gif|\.jpeg/g, function (match) {
        return "_" + size + match;
      });
  }
}

/* Render Cart*/
function ajaxrenderCart(cart, product,product_sellingplan) {
   //console.log("rendeproduct", product);
  //$('.trulySidebarModel__cartList').html('');
  var total_items = cart.items.length;
  var citems = new Array();
  if (total_items == 1) {
    $("#alreadyincart").addClass("d-none");
    $("#cartbestseller").removeClass("d-none");
  } else {
    $("#alreadyincart").removeClass("d-none");
    $("#cartbestseller").addClass("d-none");
  }
  $(".headerCartItems").html(Number(total_items)).css('visibility','visible');
  viewcartitemsArray = [];
  cart_price = cart.total_price / 100;
  carttotal = cart_price.toFixed(2);
  var alreadyincart = "";
  cart.items.forEach(function (item, index) {
    if (typeof item.selling_plan_allocation !== "undefined") {
      itmcat2 = "Subscribe & save 10 % Off";
      currentproduct_sellingplan = item.id+'_'+item.selling_plan_allocation.selling_plan.id;
    } else {
      itmcat2 = "One-time purchase";
      currentproduct_sellingplan =  item.id+'_nil';
    }
    var viewitem = {
      item_id: item.product_id,
      item_name: item.product_title,
      currency: "USD",
      item_brand: item.vendor,
      item_category: item.product_type,
      item_category2: itmcat2,
      item_list_name: "Cart Product",
      price: (item.price / 100).toFixed(2),
      quantity: item.quantity,
      item_variant: item.variant_id,
    };
    viewcartitemsArray.push(viewitem);
    var original_price = item.original_line_price / 100;
    var final_original_price = original_price.toFixed(2);
    var line = index + 1;
    var line_price = item.line_price / 100;
    var final_line_price = line_price.toFixed(2);
    var resizeproductimg = imgURL(item.image, "large");
    if (resizeproductimg) {
      resizeproductimg = resizeproductimg;
    } else {
      resizeproductimg =
        "https://cdn.shopify.com/s/files/1/0053/4462/4675/files/Truly-placeholder-image-pink.png?v=1684759789";
    }
    if ( currentproduct_sellingplan !=product_sellingplan ) {
      alreadyincart += `<div class="column-md-4 leghtafjsload">
                        <div class="productBox__outer">
                           <div class="productBox productBox__1 text-align-center ">
                                <div class="productBox__img">
                                    <div class="productBox__imgSlider">
                                        <div class="productBox__imgSlides">
                                            <a href="https://www.trulybeauty.com/products/${
                                              item.handle
                                            }" class="d-block">
                                                <img loading="lazy" src="${resizeproductimg}" class="full_img" alt="${
        item.product_title
      }">
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <a href="https://www.trulybeauty.com/products/${
                                  item.handle
                                }" class="d-block productBox__cntnt">
                                    <h5 class="productBox__title mb-1">${
                                      item.product_title
                                    }</h5>
                                </a>
                                <div class="productBox__btnHolder pb-2">
                                    <div class="productBox__price mb-2 h6">
                                        <span class="money">${theme.Currency.formatMoney(
                                          final_line_price,
                                          theme.moneyFormat
                                        )}</span>
                                        <del class="price__sale">
                                            <span class="money"></span>
                                        </del>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>`;
    }
  });
  $("#alreadyincart .product_slickslider").html(alreadyincart);
  dataLayer.push({ ecommerce: null });
  dataLayer.push({
    event: "view_cart",
    ecommerce: {
      items: viewcartitemsArray,
    },
  });
  var total_price = cart.total_price / 100;
  var final_total_price = total_price.toFixed(2);
  freeshippingbar(final_total_price);
   if(total_items == 1){
    $('.btproduct_slickslider').slick({
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      autoplay: false
    });
   }else{
    initSlickWhenReady();
   }
  
    // funtions ends
}
function initSlickWhenReady() {
  var lengthAlrincart = $('.leghtafjsload').length;
  if (viewcartitemsArray && viewcartitemsArray.length > 0) {
    var $slider = $('.product_slickslider');
    if ($slider.hasClass('slick-initialized slick-slider')) {
      if(lengthAlrincart > 0){
        //$slider.slick('unslick');
      }else{
        $slider.slick('unslick');
      }       
       //console.log('Lenght of cart',lengthAlrincart);
       $slider.removeClass('slick-initialized slick-slider');
       
    }
    $slider.slick({
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      autoplay: false
    });
  } else {
    setTimeout(initSlickWhenReady, 200);
  }
  }
$(document).on("click", ".freebee_add-to-cart", function (e) {
  e.preventDefault();
  var formID = $(this).closest("form").attr("id");
  var productid = $("#" + formID).attr("data-productid");
  var price = $("#" + formID)
    .find(".money")
    .html();
  var tprice = price.replace("$", "");
  var formdata = $(this).closest("form").serialize();
  ajaxaddProductToCart(formdata);
  $("#popup_freebie").css("display", "none").html("");
  $("html").removeClass("no-scroll");
});

//*** for showpopup code

// $(document).ready(function () {
//   getdata();
// });

// $(document).on("click", "#getproduct,.cartbox  #addToCart", function () {
//   setTimeout(function () {
//     getdata();
//   }, 1000);
// });

// function getdata() {
//   jQuery.getJSON(window.Shopify.routes.root+"cart.js", function (cart) {
//     var array1 = [];
//     var array2 = [];
//     cart.items.forEach(function (item, index) {
//       array1.push(item.id);
//     });
//     $(".upsellProdBox__content .pro_id").each(function () {
//       var value = Number($(this).val().replace(/,/g, ""));
//       array2.push(value);
//     });

//     const cartvalue = array1.filter((element) => array2.includes(element));
//     if (cartvalue.length > 0) {
//       $(".cartbox #addToCart").removeClass("open-popup");
//     } else {
//       $(".cartbox #addToCart").addClass("open-popup");
//     }
//   });
// }

// $(document).on("click", "#getproduct", function (e) {
//   e.preventDefault();
//   var formID = $(this).closest("form").attr("id");
//   var formdata = $(this).closest("form").serialize();
//   var discount = $("#" + formID)
//     .find(".discount")
//     .val();
//   $(this).attr("disabled", true);
//   $.ajax({
//     type: "POST",
//     url: window.Shopify.routes.root+"cart/add.js",
//     dataType: "json",
//     data: formdata,
//     success: function (response) {
//       $(".cartbox #addToCart").removeClass("open-popup");
//       window.location.href =
//         "https://www.trulybeauty.com/checkout?discount=" + discount;
//     },
//   });
// });

/****for showpopup upsell code end **/

$(document).on("click", ".qtyButtons, .qtyButns", function () {
  var checkdynamicbox = $(this).data("link");
  if (typeof checkdynamicbox !== "undefined") {
     window.location.href = checkdynamicbox;
  }else{
    $('#allcartitems').addClass('added_loading');
    var qty = parseInt(
      $(this).parents(".qtyCalculator, .qtyCal").find(".qtyInput").val()
    );
    var act = $(this).data("type");
    var line = $(this).data("line");
    if (qty > 9999) {
      var qty = 9999;
    }
    if (act == "plus") {
      if (qty < 9999) {
        qty++;
      }
    } else {
      if (qty > 1) {
        qty--;
      }
    }
    qty = isNaN(qty) ? 1 : qty;
    $(this).parent(".qtyCalculator").find(".qtyInput").val(qty);
    $(".trulySidebarModel__cartList").addClass("active");
    $(".cartTable").addClass("active");
    var variantid = parseInt($(this).data("variantid"));
  //id: variantid,
    var data = { quantity: qty,  line: line };
    if (typeof $(this).data("variantid") != "undefined") {
      jQuery.ajax({
        type: "post",
        url: window.Shopify.routes.root+"cart/change.js",
        data: data,
        dataType: "json",
        success: function (cart) {
          applypromos(cart);
          getcart();
          $('#allcartitems').removeClass('added_loading');
        },
      });
    }
  }  
  return false;
});

/*footer-form*/
$("form#footersubscribeform").submit(function () {
  if ($("#emailsignupchekbox").prop("checked") == false) {
    $("#emailsignupchekbox").addClass("needsfilled");
    $(".emailsignupover").addClass("needsfilledsignup");
  }
  email = $("#ftsubscribe-email");
  if (
    !/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(
      email.val()
    )
  ) {
    email.addClass("needsfilled");
    email.val("Enter valid email address");
  }
  if ($(":input").hasClass("needsfilled")) {
    return false;
  } else {
    $("button#footersubscribe").css("pointer-events", "none");
    var useremail = $("#ftsubscribe-email").val();
    $.ajax({
      url: "https://mytrulydeals.com/trulybeauty/subscribe.php",
      type: "POST",
      data: {
        ajaxaction: "subscribelist",
        subemailaddress: useremail,
      },
      async: true,
      success: function (response) {
        $("form#footersubscribeform").get(0).reset();
        $("#ftsubscribe-email").val("");
        alert("Thank you for subscribing.");
        $("button#footersubscribe").css("pointer-events", "auto");
      },
      timeout: 5000000, // sets timeout to 5 seconds
    });

    return false;
  }
});

// $("#emailsignupchekbox").change(function () {
//   $("#emailsignupchekbox").removeClass("needsfilled");
//   $(this).parent().removeClass("needsfilledsignup");
// });

$("#ftsubscribe-phone").keypress(function (e) {
  var charCode = e.which ? e.which : event.keyCode;
  if (String.fromCharCode(charCode).match(/[^0-9]/g)) return false;
});

$("form#footerphonesubscribeform").submit(function () {
  phone = $("#ftsubscribe-phone").val();
  if (phone.length < 10) {
    $("#ftsubscribe-phone").addClass("needsfilled");
    $("#ftsubscribe-phone").val("Enter valid Phone Number");
    return false;
  }
  // if ($("#smssighupcheckbox").prop("checked") == false) {
  //   $("#smssighupcheckbox").addClass("needsfilled");
  //   $(".phonesignupover").addClass("needsfilledsignup");
  // }
  if (phone == "") {
    $("#ftsubscribe-phone").addClass("needsfilled");
    $("#ftsubscribe-phone").val("Enter valid Phone Number");
  }
  if ($(":input").hasClass("needsfilled")) {
    return false;
  } else {
    $("button#footersubscribephone").css("pointer-events", "none");
    var subphonenumber = $("#ftsubscribe-phone").val();

    $.ajax({
      url: "https://mytrulydeals.com/trulybeauty/subscribe.php",
      type: "POST",
      data: {
        ajaxaction: "subscribephonelist",
        subphonenumber: subphonenumber,
      },
      async: true,

      success: function (response) {
        $("form#footerphonesubscribeform").get(0).reset();
        alert("Thank you for subscribing.");
        $("button#footersubscribephone").css("pointer-events", "auto");
      },
      timeout: 5000000, // sets timeout to 5 seconds
    });

    return false;
  }
});
// $("#smssighupcheckbox").change(function () {
//   $("#smssighupcheckbox").removeClass("needsfilled");
//   $(this).parent().removeClass("needsfilledsignup");
// });

$(":input").focus(function () {
  if ($(this).hasClass("needsfilled")) {
    $(this).val("");
    $(this).removeClass("needsfilled");
  }
});

$(".popup-content").on("click", function (e) {
  if (e.target !== this) return;
  $(this).parents(".popup").find(".popup-overlay").click();
});

/*Add to cart search listing start*/
$(document).on("click", ".search-add-to-cart-ajax", function (e) {
  e.preventDefault();
  var formID = $(this).closest("form").attr("id");
  var productid = $("#" + formID).attr("data-productid");
  var price = $("#" + formID)
    .find(".money")
    .text();
  var tprice = price.replace("$", "");

  $.ajax({
    type: "POST",
    url: window.Shopify.routes.root+"cart/add.js",
    dataType: "json",
    data: $("#" + formID).serialize(),
    success: function () {
      var num = +$(".headerCartItems").html() + 1;
      $(".headerCartItems").html(num).css('visibility','visible');
      $(".addcartmsg")
        .html("Added sucessfully to cart.")
        .fadeIn(100)
        .delay(5000)
        .fadeOut(500);
    },
    error: function () {
      $(".addcartmsg")
        .html("Unable to add product to cart.")
        .fadeIn(100)
        .delay(5000)
        .fadeOut(500);
    },
  });
});
/*Add to cart from search listing end*/

$(document).mouseup(function (e) {
  var container_hide = $(".truly_search_sidebar");

  if (
    !container_hide.is(e.target) &&
    container_hide.has(e.target).length === 0
  ) {
    container_hide.hide();
  }
});

/* Free ship side start */
$(document).on("click", ".freeshipside", function (e) {
  var date = new Date();
  date.setTime(date.getTime() + 24 * 60 * 60 * 1000);
  var myfreeshipside = getCookie("isclosefreeshipside");
  if (myfreeshipside == null) {
    document.cookie =
      "isclosefreeshipside=yes; expires=" + date.toGMTString() + "; path=/";
    $(".freeShippingBadge").hide();
  }
});
var myfreeshipside = getCookie("isclosefreeshipside");
if (myfreeshipside != null) {
  $(".freeShippingBadge").hide();
} else {
  setTimeout(function () {
    $(".freeShippingBadge").show();
  }, 5000);
}
/* Free ship side start */


/* Free freeshippingbar */
function freeshippingbar(carttotal) {

 fetch('/browsing_context_suggestions.json')
  .then(response => {
  return response.json();
})
  .then((json) => {
    
    var country = json.detected_values.country.name; 
    var loader = $("#loader");
    var bar = $(".freeShippingProgress .freeShippingProgress__bar span");
    var subtotal = carttotal;
    var time = 1000;
    if (country == "United States") {
      var free_shipping = Math.abs(75 - subtotal).toFixed(2);
      if (subtotal >= 1 && subtotal < 75 && !$('.freeShippingProgress').hasClass("ismember")) {
        $(".freeShippingProgress").removeClass("hide"); // freeShippingProgress
        $(".singleproductcart .freeShippingProgress p").html(
          "You are " +
            theme.Currency.formatMoney(free_shipping, theme.moneyFormat) +
            " away from FREE shipping"
        );
        $(".cart_sidebar .freeShippingProgress p").html(
          "You are " +
            theme.Currency.formatMoney(free_shipping, theme.moneyFormat) +
            " away from FREE shipping"
        );
        $(".product-ctaBar--inner .freeShippingProgress p").html(
          "You are " +
            theme.Currency.formatMoney(free_shipping, theme.moneyFormat) +
            " away from FREE shipping"
        );
        bar.width(subtotal);
        bar.css("width", subtotal + "%");
      } else {
        var freeshipmsg = 'Your shipping is FREE';
        if($('.freeShippingProgress').hasClass("ismember")){
          var freeshipmsg = 'Free Shipping for Members';
        }
        
        $(".singleproductcart .freeShippingProgress p").text(freeshipmsg);
        $(".cart_sidebar .freeShippingProgress p").text(freeshipmsg);
        $(".product-ctaBar--inner .freeShippingProgress p").text(freeshipmsg);
        bar.css("width", "100%");
      }
    } else {
      $(".freeShippingProgress").addClass("hide");
    }
   
  });
}

/*Santa Hat sale*/
// function santahatsale(cart) { 
//   checksantahatincart = 0;
//    cart.items.forEach(function (item, index) {
//  if (item.product_id == santahatproductid ) {
//         checksantahatincart = item.line_price;
//       }
//    });
  
//   discarttotal = cart.original_total_price-checksantahatincart-cart.total_discount;
//   carttotal = discarttotal/100;
  
//   fetch('/browsing_context_suggestions.json')
//   .then(response => {
//   return response.json();
// })
//   .then((json) => {
    
//     var country = json.detected_values.country.name; 
//     var loader = $("#loader");
//     var bar = $(".shantasale .shantadayProgress__bar span");
//     var subtotal = carttotal;
//     var time = 1000;
//     if (country == "United States" ) { //|| country == "India"
//       var free_shipping = Math.abs(santahatpprice - subtotal).toFixed(2);
//       if (subtotal >= 1 && subtotal < santahatpprice && !$('.free_shipping').hasClass("ismember")) {
//         $(".freeShippingProgress").removeClass("hide"); // freeShippingProgress
//         $(".singleproductcart .freeShippingProgress p").html(
//           "Only " +
//             theme.Currency.formatMoney(free_shipping, theme.moneyFormat) +
//             " Away from Your FREE Gift and FREE Shipping"
//         );
//         $(".shantasale__content p").html(
//           "Only " +
//             theme.Currency.formatMoney(free_shipping, theme.moneyFormat) +
//             " Away from Your FREE Gift and FREE Shipping"
//         );
//         $(".product-ctaBar--inner .freeShippingProgress p").html(
//           "Only " +
//             theme.Currency.formatMoney(free_shipping, theme.moneyFormat) +
//             " Away from Your FREE Gift and FREE Shipping"
//         );
//         bar.width(subtotal);
//         bar.css("width", subtotal + "%");
//         $('.shantadayProgress__steps .step').html('FREE Shipping<br><span class="free-gift">+ FREE Gift</span>').removeClass('active');
//       }
//       else {
//         var freeshipmsg = 'Your shipping is FREE';
//         if($('.freeShippingProgress').hasClass("ismember")){
//           var freeshipmsg = 'Free Shipping for Members';
//         }
//         $(".singleproductcart .freeShippingProgress p").text(freeshipmsg);
//         $(".product-ctaBar--inner .freeShippingProgress p").text(freeshipmsg);
//         bar.css("width", "100%");
//             $(".shantasale__content p").html("FREE Gift Automatically Added to Cart");
//              $('.shantadayProgress__steps .step').html('FREE Shipping<br><span class="free-gift">+ FREE Gift</span>').addClass('active');
           
//       }
//     } else {
//       $('.stepfreeshipping').addClass('d-none');
//       $(".free_shipping").addClass('d-none');
//       $(".freeShippingProgress").addClass("hide");
//        if (carttotal < santahatpprice) {
//              var free_shipping = Math.abs(santahatpprice-carttotal).toFixed(2);
//              $(".shantasale__content p").html("Only "+(theme.Currency.formatMoney(free_shipping, theme.moneyFormat))+" away from a FREE Gift");
//               var total = carttotal / santahatpprice;
//               var final_total = total * 100;
//               bar.width(final_total + "%");
//               bar.css("width", final_total + "%");
//          $('.shantadayProgress__steps .step').html('<span class="free-gift">FREE Gift</span>').removeClass('active');
//            }
//            else {
//             $(".shantasale__content p").html("FREE Gift Automatically Added to Cart");
//               bar.width(100);
//             bar.css("width", "100%");
//             $('.shantadayProgress__steps .step').html('<span class="free-gift">FREE Gift</span>').addClass('active');
//            }
//     }
// })
// }
/*santa hat sale*/

/*black friday sale*/
// function blackfridaysale(cart) { 
//   checkfreeproductincart = 0;
//   freeproductprice = 100;

//    cart.items.forEach(function (item, index) {
//   if (item.variant_id == 40920114954275 ) {
//         checkfreeproductincart = item.line_price;
//       }
//    });
  
//   discarttotal = cart.original_total_price-checkfreeproductincart-cart.total_discount;
//   carttotal = discarttotal/100;
 
  
//   fetch('/browsing_context_suggestions.json')
//   .then(response => {
//   return response.json();
// })
//   .then((json) => {
    
//     var country = json.detected_values.country.name; 
//     var loader = $("#loader");
//     var bar = $(".blackfridaysale .blackfridayProgress__bar.free_shipping span");
//     var bar1 = $('.blackfridayProgress__bar.mystery_bag span');
//     var subtotal = carttotal;
//     var time = 1000;
//     if (country == "United States" || country == "India") {
//       var free_shipping = Math.abs(75 - subtotal).toFixed(2);
//       var freegift = Math.abs(freeproductprice-carttotal).toFixed(2);
//       if (subtotal >= 1 && subtotal < 75 && !$('.free_shipping').hasClass("ismember")) {
//         $(".freeShippingProgress").removeClass("hide"); // freeShippingProgress
//         $(".singleproductcart .freeShippingProgress p").html(
//           "Only " +
//             theme.Currency.formatMoney(free_shipping, theme.moneyFormat) +
//             " Away from FREE Shipping"
//         );
//         $(".blackfridaysale__content p").html( 
//           "Only " +
//             theme.Currency.formatMoney(free_shipping, theme.moneyFormat) +
//             " away from free shipping and "+ theme.Currency.formatMoney(freegift, theme.moneyFormat) +" away from free gift!"
//         );
//         $(".product-ctaBar--inner .freeShippingProgress p").html(
//           "Only " +
//             theme.Currency.formatMoney(free_shipping, theme.moneyFormat) +
//             " Away from FREE Shipping"
//         );
//        // alert(subtotal);
//         bar.width(subtotal);
//         bar.css("width", subtotal + "%");
//         bar1.width(0);
//               bar1.css("width", "0%");
//         $('.stepfreeshipping').removeClass('active');
//         $('.stepmysterypage').removeClass('active');
//       }
//       else {
//         var freeshipmsg = 'Your shipping is FREE';
//         if($('.freeShippingProgress').hasClass("ismember")){
//           var freeshipmsg = 'Free Shipping for Members';
//         }
//         $('.stepfreeshipping').addClass('active');
//         $(".singleproductcart .freeShippingProgress p").text(freeshipmsg);
//         $(".product-ctaBar--inner .freeShippingProgress p").text(freeshipmsg);
//         bar.css("width", "100%");
//         $('.stepmysterypage').removeClass('active');
//         if (carttotal < freeproductprice) {
//              var free_shipping = Math.abs(freeproductprice-carttotal).toFixed(2);
//              $(".blackfridaysale__content p").html("Only "+(theme.Currency.formatMoney(free_shipping, theme.moneyFormat))+" away from free gift!");
//               var total = carttotal / freeproductprice;
//               var final_total = total * 100;
//               bar1.width(final_total + "%");
//               bar1.css("width", final_total + "%");
//           $('.stepmysterypage').removeClass('active');
//            }
//            else {
//             $(".blackfridaysale__content p").html("Free Gift Automatically Added to Cart");
//               bar1.width(100);
//             bar1.css("width", "100%");
//              $('.stepmysterypage').addClass('active');
//            }
//       }
//     } else {
//       $('.stepfreeshipping').addClass('d-none');
//       $(".free_shipping").addClass('d-none');
//       $(".freeShippingProgress").addClass("hide");
//        if (carttotal < freeproductprice) {
//              var free_shipping = Math.abs(freeproductprice-carttotal).toFixed(2);
//              $(".blackfridaysale__content p").html("Only "+(theme.Currency.formatMoney(free_shipping, theme.moneyFormat))+" away from free gift!");
//               var total = carttotal / freeproductprice;
//               var final_total = total * 100;
//               bar1.width(final_total + "%");
//               bar1.css("width", final_total + "%");
//               $('.stepmysterypage').removeClass('active');
//            }
//            else {
//             $(".blackfridaysale__content p").html("Free Gift Automatically Added to Cart");
//               bar1.width(100);
//             bar1.css("width", "100%");
//              $('.stepmysterypage').addClass('active');
//            }
//     }
// })
// }
/*black friday sale*/

// single product main slider

// popup jQuery
(function ($) {
  $.fn.openPopup = function (settings) {
    var elem = $(this);
    // Establish our default settings
    var settings = $.extend(
      {
        anim: "fade",
      },
      settings
    );
    elem.show();
    elem.find(".popup-content").addClass(settings.anim + "In");
  };

  $.fn.closePopup = function (settings) {
    var elem = $(this);
    // Establish our default settings
    var settings = $.extend(
      {
        anim: "fade",
      },
      settings
    );
    elem
      .find(".popup-content")
      .removeClass(settings.anim + "In")
      .addClass(settings.anim + "Out");
    setTimeout(function () {
      elem.hide();
      elem.find(".popup-content").removeClass(settings.anim + "Out");
    }, 500);
  };
})(jQuery);

// Click functions for popup
$(document).on("click", ".open-popup", function () {
  $(".popUpSlider").slick("unslick");
  setTimeout(function () {
    $(".popUpSlider").slick(options);
  }, 200);
  $("html").addClass("noscroll");
  if (typeof $(this).data("subpercent") !== "undefined") {
    $(".subpercent").html($(this).data("subpercent"));
  }
  if (typeof $(this).data("subsingle") !== "undefined") {
    $(".subsingle").html($(this).data("subsingle"));
  }
  if (typeof $(this).data("bydquickview") !== "undefined") {
    $(".popup").addClass("popuponRight");
  }

  $("#" + $(this).data("id")).openPopup({
    anim:
      !$(this).attr("data-animation") || $(this).data("animation") == null
        ? "fade"
        : $(this).data("animation"),
  });
});
$(document).on("click", ".close-popup", function () {
  $("html").removeClass("noscroll");
  $("#" + $(this).data("id")).closePopup({
    anim:
      !$(this).attr("data-animation") || $(this).data("animation") == null
        ? "fade"
        : $(this).data("animation"),
  });

  // for popup open video pause
  // $(".videoPopup").find('video').get(0).pause()
});
$(".popup-overlay").click(function () {
  $("html").removeClass("noscroll");
  $("#" + $(this).parents(".popup").find(".close-popup").data("id")).closePopup(
    {
      anim:
        !$(this).attr("data-animation") || $(this).data("animation") == null
          ? "fade"
          : $(this).data("animation"),
    }
  );

  // for popup open video pause
  // $(".videoPopup").find('video').get(0).pause()
});
$(".popup-content").on("click", function (e) {
  if (e.target !== this) return;
  $(this).parents(".popup").find(".popup-overlay").click();
});

/* Reviews Load */
function loadstampedreviews() {
  //console.log('g');
  var lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));

  if ("IntersectionObserver" in window) {
    let lazyImageObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          let lazyImage = entry.target;
          lazyImage.src = lazyImage.dataset.src;
          // console.log(lazyImage.src );
          //  lazyImage.srcset = lazyImage.dataset.srcset;
          lazyImage.classList.remove("lazy");
          lazyImageObserver.unobserve(lazyImage);
        }
      });
    });

    lazyImages.forEach(function (lazyImage) {
      lazyImageObserver.observe(lazyImage);
    });
  } else {
    // Possibly fall back to event handlers here
    //console.log('fail');
  }
  StampedFn.reloadUGC();
}

// Click function for quickview
$("body").on("click", ".open-quickviewpopup", function () {
  var dataslug = $(this).attr("data-slug");
  //alert(dataslug);
  function productvariation_switch_popup() {
    var variationID = $(
      ".popup-quickView-wrap .product-form__variants option:selected"
    ).val();
    //alert(variationID);
    var productUrl = "https://www.trulybeauty.com/products/" + dataslug;
    var onetimesubscribeoption = $(
      "input[type=radio][name=sellingplan_option]:checked"
    ).val();
    jQuery.getJSON(productUrl + ".js", function (product) {
      $.each(product.variants, function (i) {
        if (product.variants[i].id == variationID) {
          var price = product.variants[i].price;
          var compare_price = product.variants[i].compare_at_price;

          if (product.variants[i].featured_media != null) {
            var variantimageID = product.variants[i].featured_media.id;
          }

          if (
            typeof onetimesubscribeoption !== "undefined" &&
            onetimesubscribeoption == "subscription"
          ) {
            //
            var subscribeprice =
              product.variants[i].selling_plan_allocations[0]
                .price_adjustments[0].price;
            $(".onetime_purchase .moneyprice > .money").html(
              theme.Currency.formatMoney(price, theme.moneyFormat)
            );
            $(".onetime_purchase .moneyprice > .compare-pp").html(
              theme.Currency.formatMoney(compare_price, theme.moneyFormat)
            );
            $(".subscription_purchase .moneyprice > .money").html(
              theme.Currency.formatMoney(subscribeprice, theme.moneyFormat)
            );
            $(".subscription_purchase .moneyprice > .compare-pp").html(
              theme.Currency.formatMoney(compare_price, theme.moneyFormat)
            );
            var sellingplan = $('select[name="selling_plan"]').val();
            $.each(product.variants[i].selling_plan_allocations, function (j) {
              if (
                sellingplan ==
                product.variants[i].selling_plan_allocations[j].selling_plan_id
              ) {
                var price =
                  product.variants[i].selling_plan_allocations[j].price;
                $(".product-form__variants")
                  .closest("form")
                  .find(".productprice > span.money")
                  .html(
                    theme.Currency.formatMoney(
                      subscribeprice,
                      theme.moneyFormat
                    )
                  );
              }
            });
          } else {
            if (product.variants[i].selling_plan_allocations != "") {
              var subscribeprice =
                product.variants[i].selling_plan_allocations[0]
                  .price_adjustments[0].price;
              $(".onetime_purchase .moneyprice > .money").html(
                theme.Currency.formatMoney(price, theme.moneyFormat)
              );
              $(".onetime_purchase .moneyprice > .compare-pp").html(
                theme.Currency.formatMoney(compare_price, theme.moneyFormat)
              );
              $(".subscription_purchase .moneyprice > .money").html(
                theme.Currency.formatMoney(subscribeprice, theme.moneyFormat)
              );

              $(".subscription_purchase .moneyprice > .compare-pp").html(
                theme.Currency.formatMoney(compare_price, theme.moneyFormat)
              );
            }
            $(".product-form__variants")
              .closest("form")
              .find(".productprice > span.money")
              .html(theme.Currency.formatMoney(price, theme.moneyFormat));
          }
          if (variantimageID) {
            $(".productSliderNav img").each(function () {
              if ($(this).attr("id") == variantimageID) {
                $(this).click();
                $(this).parent().parent().addClass("slick-current");
              }
            });
          }
        }
      });
    });
  }
  $("#quickviewresponse")
    .addClass("text-align-center")
    .html(
      '<img src="https://cdn.shopify.com/s/files/1/0053/4462/4675/files/loader.gif?v=1632226619" width="100">'
    );
  $.ajax({
    url: "https://www.trulybeauty.com/products/" + dataslug + "?section_id=quickviewpopup",
    type: "GET",
    success: function (reviewsresponse) {
      $("#quickviewresponse")
        .removeClass("text-align-center")
        .html(reviewsresponse);
      setTimeout(function () {
        loadstampedreviews();
        productvariation_switch_popup();
        $(".product-form__variants").on("change", function () {
          productvariation_switch_popup();
        });
        $(".productSliderNav").not(".slick-initialized").slick(prodNavSlider);
        $(".productSliderMain").not(".slick-initialized").slick(prodmainSlider);

        $(document).on('change',"input:radio[name=sellingplan_option]",function () {
          if ($(this).attr("value") == "onetime") {
            $(".purchase-btn-txt").text($(this).attr('data-state'));
            $(".buying_qtySelect").addClass('show_select').siblings().removeClass('show_select');
          }
          if ($(this).attr("value") == "subscription") {
            $(".purchase-btn-txt").text($(this).attr('data-state'));
            $(".buying_subsSelect").addClass('show_select').siblings().removeClass('show_select');
          }
        });

        $(".productSliderMain").on("afterChange", function (t, e, o) {
          var s = $(e.$slides[o]).find("video");
          s.length > 0
            ? $(s).get(0).play()
            : $(".mediaVideo").each(function () {
                $(this).get(0).pause(), ($(this).get(0).currentTime = 0);
              });
        });
        $(".photoswipe-wrapper").each(function () {
          $(this)
            .find("a")
            .each(function () {
              $(this).attr("data-size", "800x1000");
            });
        });

        initPhotoSwipeFromDOM(".photoswipe-wrapper");
      }, 1000);
    },
    timeout: 5000000, // sets timeout to 5 seconds
  });
  $("html").addClass("noscroll");
  $("#" + $(this).data("id")).openPopup({
    anim:
      !$(this).attr("data-animation") || $(this).data("animation") == null
        ? "fade"
        : $(this).data("animation"),
  });
});
$("body").on("click", ".newquickviewpopup", function () {
    var dataslug = $(this).attr("data-slug");
    //alert(dataslug);
    $("#quickviewresponse")
      .addClass("text-align-center")
      .html(
        '<img src="https://cdn.shopify.com/s/files/1/0053/4462/4675/files/loader.gif?v=1632226619" width="100">'
      );
      fetch(
        `/products/${dataslug}?section_id=new_quickviewpopup`
      )
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            this.close();
            throw error;
          }
    
          return response.text();
        })
        .then((text) => {

          const resultsMarkup = new DOMParser()
            .parseFromString(text, "text/html")
            .querySelector(".productquickviewpopup").innerHTML;
          
          $("#quickviewresponse").removeClass("text-align-center").html(resultsMarkup);
          setTimeout(function () {
          loadstampedreviews();
          
          $(document).on('change',"input:radio[name=sellingplan_option]",function () {
            if ($(this).attr("value") == "onetime") {
              $(".purchase-btn-txt").text($(this).attr('data-state'));
              $(".buying_qtySelect").addClass('show_select').siblings().removeClass('show_select');
            }
            if ($(this).attr("value") == "subscription") {
              $(".purchase-btn-txt").text($(this).attr('data-state'));
              $(".buying_subsSelect").addClass('show_select').siblings().removeClass('show_select');
            }
          });
        }, 1000);
    
          
        })
        .catch((error) => {
          throw error;
        });        
    $("html").addClass("noscroll");
    $("#" + $(this).data("id")).openPopup({
      anim:
        !$(this).attr("data-animation") || $(this).data("animation") == null
          ? "fade"
          : $(this).data("animation"),
    });
  });
// single image slider
$(".SingleImgSlider").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: false,
  arrows: true,
  infinite: false,
  prevArrow: $(".onhalfSliderLeft__btnLeft"),
  nextArrow: $(".onhalfSliderLeft__btnRight"),
});

// popop slider
var options = {
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  adaptiveHeight: true,
  dots: true,
};
$(".popUpSlider").slick(options);

// video play pause button
var num_var = 0;
var num_var1 = 0;
$(document).ready(function () {
  $(document).on("click", ".playpauseBtn", function () {
    if ($(this).hasClass("w_how")) {
      var link = $(this)
        .parents(".PlayVideoBox")
        .find(".PlayTargetVideo")
        .attr("data-src");
      $("#mydVideo.w_how source").attr("src", link);
      var video = $(this)
        .parents(".PlayVideoBox")
        .find(".PlayTargetVideo")
        .get(0);
      video.addEventListener("ended", myHandler, false);
      $(this).toggleClass("active");
      if (num_var == 0) {
        video.load();
        video.play();
      } else {
        if (video.paused === true) {
          video.play();
          $(this).addClass("active");
        } else {
          video.pause();
          $(".playpauseBtn").removeClass("active");
        }
      }
      if (num_var < 3) {
        num_var++;
      }
      function myHandler(e) {
        $(this)
          .parents(".PlayVideoBox")
          .find(".playpauseBtn")
          .removeClass("active");
      }
    } else if ($(this).hasClass("w_target")) {
      var link = $(this)
        .parents(".PlayVideoBox")
        .find(".PlayTargetVideo")
        .attr("data-src");
      $("#mydVideo.w_target source").attr("src", link);
      var video = $(this)
        .parents(".PlayVideoBox")
        .find(".PlayTargetVideo")
        .get(0);
      video.addEventListener("ended", myHandler, false);
      $(this).toggleClass("active");
      if (num_var1 == 0) {
        video.load();
        video.play();
      } else {
        if (video.paused === true) {
          video.play();
        } else {
          video.pause();
        }
      }
      if (num_var1 < 3) {
        num_var1++;
      }
      function myHandler(e) {
        $(this)
          .parents(".PlayVideoBox")
          .find(".playpauseBtn")
          .removeClass("active");
      }
    } else {
      var video = $(this)
        .parents(".PlayVideoBox")
        .find(".PlayTargetVideo")
        .get(0);
      video.addEventListener("ended", myHandler, false);
      // $(this).toggleClass("active");
      $(".playpauseBtn").removeClass("active");
      if (video.paused === true) {
        video.play();
        $(this).addClass("active");
      } else {
        video.pause();
        $(".playpauseBtn").removeClass("active");
      }

      function myHandler(e) {
        $(this)
          .parents(".PlayVideoBox")
          .find(".playpauseBtn")
          .removeClass("active");
        $(this).parents(".PlayVideoBox").removeClass("active");
      }
    }
  });
});

$(document).on("change", ".qtyInput", function () {
  var qty = $(this).val();
  var variantid = parseInt($(this).data("variantid"));
  if (qty > 0) {
    $(".cartTable").addClass("active");
    var data = {
      quantity: qty,
      id: variantid,
    };
    jQuery.ajax({
      type: "post",
      url: window.Shopify.routes.root+"cart/change.js",
      data: data,
      success: function (cart) {
        cart.items.forEach(function (item, index) {
          //alert();
          if (item.product_id == 6604044173347 && item.line_price == 25000) {
            $.ajax({
              type: "POST",
              url: window.Shopify.routes.root+"cart/update.js",
              data: {
                updates: {
                  39445038497827: 0,
                },
              },
              dataType: "json",
              success: function (stuff) {
                
              },
            });
          }
        });
      },
      dataType: "json",
    });
  }
});
/*Add to cart from cart page end*/

/*remove from cart start*/
$(document).on("click", ".remove_cart_item", function (e) {
  $('#allcartitems').addClass('added_loading');
  var productId = $(this).data("productid");
  var producthandle = $(this).data("producthandle");
  var variationId = $(this).data("id");
  var line = $(this).data("line");
  var date = new Date();
  var removeitemquantity = $(this).data("quantity");
  removeupsellproArray = [];
  removecartitemsArray = [];
  date.setTime(date.getTime() + 24 * 60 * 60 * 1000);
  const quantity = 0;  
  if(variationId == 40400099803171){
     $('.freeShippingProgress').removeClass('ismember');
    $('#memebership_join').prop("disabled", false).html('ADD TO BAG & SAVE').attr( "onClick", "addmembership(this);");
  }
  if($(this).hasClass('savepack')){
    $.ajax({
  type: "GET",
  url: window.Shopify.routes.root+"cart.js",
  dataType: "json",
  async: true,
    success: function (cart) {
      cart.items.forEach(function (item, index) {
        $.each(item.properties, function (key, val) {
          indexid = index+1;
          if(key == '_bundle' || key == '_free_with'){
            $.ajax({
                url: window.Shopify.routes.root+"cart/change.js",
                type: "POST",
                async:false,
                data: '{"line":'+indexid+', "properties":{ "_remove": true } }', 
                contentType: "application/json",
                dataType: 'json'
            });
          }
          
        })
        });
      $.ajax({
    type: "POST",
    url: window.Shopify.routes.root+"cart/change.js",
    data: "quantity=" + quantity + "&line=" + line,
    dataType: "json",
    success: function (cart) {
      
         applypromos(cart);
         getcart();
      $('#allcartitems').removeClass('added_loading');
    },
  });
    }
  });
    
  }else if($(this).hasClass('serumkit')){
    $.ajax({
          type: "POST",
          url: window.Shopify.routes.root+"cart/clear.js",
          dataType: "json",
          async:false,
          success: function (data) {
            
         getcart();
      $('#allcartitems').removeClass('added_loading');
          }
        });
    
  }else if(productId == '6976030638115'){
    $.ajax({
    type: "POST",
    url: window.Shopify.routes.root+"cart/change.js",
    data: "quantity=" + quantity + "&line=" + line,
    dataType: "json",
    success: function (cart) {
         $.ajax({
          type: "GET",
          url: window.Shopify.routes.root+"cart.js",
          dataType: "json",
          async: true,
            success: function (cart) {
              cart.items.forEach(function (item, index) {
                $.each(item.properties, function (key, val) {
                  indexid = index+1;
                  if(key == '_inveterate_free_signup_gift'){
                    $.ajax({
                        type: "POST",
                        url: window.Shopify.routes.root+"cart/change.js",
                        data: "quantity=0&line=" + indexid,
                        dataType: "json",
                        success: function (cart) {
                            applypromos(cart);
                            getcart();
                            $('#allcartitems').removeClass('added_loading');
                        },
                    });
                  }  
                })
                });
            }
          });
    }
  });
    
  }else{
    $.ajax({
    type: "POST",
    url: window.Shopify.routes.root+"cart/change.js",
    data: "quantity=" + quantity + "&line=" + line,
    dataType: "json",
    success: function (cart) {
     
         applypromos(cart);
         getcart();
      $('#allcartitems').removeClass('added_loading');
    },
  });
  }
});
/*remove from cart end */

/*sidebar-popup-form*/
$("form#customer_login").submit(function () {
  required = ["customer_password"];
  email = $("#customer_email");
  for (i = 0; i < required.length; i++) {
    var input = $("#" + required[i]);
    if (input.val() == "") {
      input.addClass("needsfilled");
      input.val('This field is requried.');
      //input.attr("placeholder", "This field is requried.");
    } else {
      input.removeClass("needsfilled");
    }
  }
  if (
    !/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(
      email.val()
    )
  ) {
    email.addClass("needsfilled");
    email.val("Enter valid email address");
  }
  if ($(":input").hasClass("needsfilled")) {
    return false;
  } else {
    return true;
  }
});
$(".forget__pswd a").click(function () {
  $(".LoginPage--form").addClass("hide");
  $(".recover__password").removeClass("hide");
  $(".recover__password").addClass("show");
});
$(".forgetCancel a").click(function () {
  $(".LoginPage--form").removeClass("hide");
  $(".recover__password").removeClass("show");
  $(".recover__password").addClass("hide");
});
$("#reset_password").submit(function () {
  email = $("#recover-email");
  if (
    !/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(
      email.val()
    )
  ) {
    email.addClass("needsfilled");
    email.val("Enter valid email address");
  }
  if ($(":input").hasClass("needsfilled")) {
    return false;
  } else {
    return true;
  }
});
$("#RegisterForm").submit(function () {
  required = [
    "RegisterForm-FirstName",
    "RegisterForm-LastName",
    "RegisterForm-password",
  ];
  email = $("#RegisterForm-email");
  passwordval = $("#RegisterForm-password");
  for (i = 0; i < required.length; i++) {
    var input = $("#" + required[i]);
    if (input.val() == "") {
      input.addClass("needsfilled");
      input.val('This field is requried.');
      //input.attr("placeholder", "This field is requried.");
    } else {
      input.removeClass("needsfilled");
    }
  }
  if (
    !/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(
      email.val()
    )
  ) {
    email.addClass("needsfilled");
    email.val("Enter valid email address");
  }
  // new validations on password
  if(passwordval.val().length >= 8 && /[!,%,&,@,#,$,^,*,?,_,~,<,>]/.test(passwordval.val()) && /[0-9]/.test(passwordval.val()) && /[a-z]/.test(passwordval.val()) && /[A-Z]/.test(passwordval.val())){
    passwordval.removeClass("needsfilled");
   }else{
    passwordval.addClass("needsfilled");
    passwordval.val("Password must meet all the following conditions");
   }
   // end
  if ($(":input").hasClass("needsfilled")) {
    return false;
  } else {
    //console.log("user register");
    return true;
  }
});
$(":input").focus(function () {
  if ($(this).hasClass("needsfilled")) {
    $(this).val("");
    $(this).removeClass("needsfilled");
    $("#RegisterForm-password").attr("type", "password");
  }
});

$("#RegisterForm-FirstName, #RegisterForm-LastName").bind("input", function () {
  var c = this.selectionStart,
    r = /[^a-z0-9 .]/gi,
    v = $(this).val();
  if (r.test(v)) {
    $(this).val(v.replace(r, ""));
    c--;
  }
  this.setSelectionRange(c, c);
});

$(document).on(
  "keypress",
  'input[name="customer_attributes[first_name]"]',
  function (e) {
    var key = e.keyCode;
    if (key >= 48 && key <= 57) {
      e.preventDefault();
    }
  }
);

/**singleproduct*/
$(".choose-cartMode").on("click", function () {
  $(this).addClass("active").siblings().removeClass("active");
});

$(document).on("change","input:radio[name=sellingplan_option]",function () {
  $(".qtyCalculator").find(".qtyInput").val("1");
  if ($(this).attr("value") == "onetime") {
    $(this).closest("form").find(".purchase-btn-txt").text($(this).attr('data-state'));
    $(".pre-order").text("Pre-Order Now");
     $(".buying_qtySelect").addClass('show_select').siblings().removeClass('show_select');
    $('.bwp-buy-now-toggle-container').removeClass('d-none');
    if($(this).hasClass('packpdp')){$('.buying_cartBtn button').addClass('qtyaddtocart');}
  }

  if ($(this).attr("value") == "subscription") {
     $('.buying_cartBtn button').removeClass('qtyaddtocart');
    $(this).closest("form").find(".purchase-btn-txt").text($(this).attr('data-state'));
    $(".pre-order").text($(this).attr('data-state'));
     $(".buying_subsSelect").addClass('show_select').siblings().removeClass('show_select');
    $('.bwp-buy-now-toggle-container').addClass('d-none');
  }
});

// function radioCheck(){
//   var sellingoptiona = $('input[name="sellingplan_option"]:checked').val();
//    if (sellingoptiona == "onetime") {
//      $('.bwp-buy-now-toggle-container').removeClass('d-none');
//    }
//    if (sellingoptiona == "subscription") {
//       $('.bwp-buy-now-toggle-container').addClass('d-none');
//    }
// }
// // Point the query selector to the <body>'s class name
// const bwpTargetNode = document.querySelector(".template-product");
// // What to observe
// const bwpConfig = { subtree: true, childList: true };
// // Execute mutations
// const bwpCallback = (mutationList, observer) => {
//     for (const mutation of mutationList) {
//         if (mutation.type === "childList") {
//             radioCheck();
//         }
//     }
// };

// if ($("body").hasClass("template-product")) {
// // Create an observer variable

// const bwpObserver = new MutationObserver(bwpCallback);
// // Start observing the target node
// bwpObserver.observe(bwpTargetNode, bwpConfig);

// }
$("input:radio[name=sellingplan_option]", this).first().click();

$(".suscribe__productInfo input:radio").click(function () {
  // alert('radio');
  $(".subCheck.active").removeClass("active");
  if ($(this).is(":checked") && $(this).hasClass("raio-btn")) {
    $(this).parent().addClass("active");
  } else {
    $(".subCheck.active").removeClass("active");
    //$(this).removeClass('active').addClass('');
  }
});

$(document).on(
  "change",
  "input[type=radio][name=sellingplan_option]",
  function () {
    var selectedoption = $(this).val();
    var changessubprice = $(this).parent().find(".moneyprice").html(); //alert(changessubprice);
    if (
      $(this).closest("form").find(".productprice").hasClass("price--on-sale")
    ) {
      $(this)
        .closest("form")
        .find(".productprice.price--on-sale > span.money")
        .html(changessubprice);
    } else {
      $(this).closest("form").find(".productprice").html(changessubprice);
    }
    // if (selectedoption == "onetime") {
    //   $(this).closest("form").find(".selling_plan").attr("name", "").attr('disabled', 'disabled');
    //     // .css("display", "none");
    // } else if (selectedoption == "subscription") {
    //   $(this).closest("form").find(".selling_plan").attr("name", "selling_plan").attr('disabled', false);
    //     // .css("display", "block");
    // }
  }
);

var secondimage = 0;
if ($("#secondimageshow").val() == 1) {
  var secondimage = 1;
}

if ($("body").hasClass("template-build-your-bundle") || $("body").hasClass("template-article")) {
    var prodmainSlider = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: false,
    infinite: false,
    asNavFor: ".productSliderNav",
    responsive: [{ breakpoint: 751, settings: "unslick" }],
  };
} else {
var prodmainSlider = {
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  infinite: false,
  asNavFor: ".productSliderNav",
  initialSlide: secondimage,

  responsive: [
    { breakpoint: 751, settings: "unslick" },
  ],
};

var prodNavSlider = {
  slidesToShow: 5,
  slidesToScroll: 1,
  asNavFor: ".productSliderMain",
  dots: false,
  centerMode: false,
  focusOnSelect: true,
  infinite: false,
  vertical: true,
  arrows: true,
  verticalSwiping: false,
  initialSlide: secondimage,
  responsive: [
    { breakpoint: 1251, settings: { slidesToShow: 4 } },
    { breakpoint: 1101, settings: { slidesToShow: 4 } },
    { breakpoint: 990, settings: { slidesToShow: 6 } },
    { breakpoint: 751, settings: "unslick" },
  ],
};
}
$(".productSliderMain").slick(prodmainSlider);
$(".productSliderNav").slick(prodNavSlider);

$(".productSliderMain, .popUpSlider").on("afterChange", function (t, e, o) {
  var s = $(e.$slides[o]).find("video");
  s.length > 0
    ? $(s).get(0).play()
    : $(".mediaVideo").each(function () {
        $(this).get(0).pause(), ($(this).get(0).currentTime = 0);
      });
});

$(document).on("click", ".trulyAccordian .trulyAccordian__toggle", function () {
  $(this).parent().siblings().removeClass("active"),
    $(this).parent().siblings().find(".trulyAccordian__cntnt").slideUp(),
    $(this).parent().toggleClass("active"),
    $(this).next(".trulyAccordian__cntnt").slideToggle(200);
  setTimeout(() => {
    $("body, html").animate(
      { scrollTop: $(this).parents(".trulyAccordianHolder").offset().top-200 },
      600
    );
  }, 50);
});

$(document).on(
  "click",
  ".accordianHolder__Mobile .accordian__mob",
  function () {
    $(this).parent().siblings().removeClass("active"),
      $(this).parent().siblings().find(".accordian__cntntMobile").slideUp(),
      $(this).parent().toggleClass("active"),
      $(this).next(".accordian__cntntMobile").slideToggle(200);
  }
);

$(document).on("click", ".playPauseClick", function () {
  var video = $(this).parents(".PlayVideoWrap").find(".PlayWrapVideo").get(0);
  // $(this).toggleClass("active");
  $(".playPauseClick").removeClass("active");
  if (video.paused === true) {
    video.play();
    $(this).addClass("active");
  } else {
    video.pause();
    $(".playPauseClick").removeClass("active");
  }
});

//tab
$(".trulyTab li").click(function () {
  var tab_id = $(this).attr("data-tab");
  // $('ul.trulyTab li').removeClass('current');
  $(this).siblings().removeClass("current");
  // $('.trulyTab__cntnt').removeClass('current');
  $("#" + tab_id)
    .siblings()
    .removeClass("current");
  $(this).addClass("current");
  $("#" + tab_id).addClass("current");
});

// whatpeopleSay
$(".whatpeopleSay").slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
  responsive: [
    {
      breakpoint: 990,
      settings: { slidesToShow: 2, slidesToScroll: 1 },
    },
    {
      breakpoint: 576,
      settings: { slidesToShow: 1, slidesToScroll: 1 },
    },
  ],
});

// three product slider
$(".shopSliderThree").slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,
  adaptiveHeight: true,
  dots: false,
  responsive: [
    { breakpoint: 990, settings: { slidesToShow: 2 } },
    { breakpoint: 349, settings: { slidesToShow: 1 } },
  ],
});

$(document).on("change", ".rc_widget__option__input", function () {
  var changesubprice = $(this).parent().find(".rc_widget__price").html();
  $(this).closest("form").find(".money").html(changesubprice);
});

/*For AB Testing nav start*/
var resetb = document.getElementById("resetb");
var offcansearch = document.getElementById("offSearch");

if (offcansearch != null) {
  offcansearch.addEventListener("keyup", function () {
    var searchSminput = offcansearch.value.length;
    if (searchSminput > 2) {
      resetb.style.display = "flex";
    } else {
      resetb.style.display = "none";
    }
  });
}
if (resetb != null) {
  resetb.addEventListener("click", function () {
    resetb.style.display = "none";
    offcansearch.focus();
    $(".searchResult").css("display", "none");
  });
}
$(".mobNav__toggle").click(function () {
  $("html").toggleClass("open--nav");
  $(".freshNav__holder").slideToggle(300);
  $(".freshNav__holder").addClass("open--holder");
});

function hidenavMenu() {
  $("html").removeClass("open--nav"), $(".freshNav__holder").slideUp(300);
  $(".freshNav__holder").removeClass("open--holder");
}

// mobile dropdown nav
$(".mobTitle").click(function () {
  $(this).parent().siblings().removeClass("active"),
    $(this).parent().siblings().find(".freshMob__menuList").slideUp(),
    $(this).next(".freshMob__menuList").slideToggle(),
    $(this).parent().toggleClass("active");
});
/*For AB Testing nav end*/

function copyDiscountCode(tooltips) {
  var copyText = document.getElementById("myInput");
  copyText.select();
  copyText.setSelectionRange(0, 99999);
  navigator.clipboard.writeText(copyText.value);
  var tooltip = document.getElementById(tooltips);
  tooltip.innerHTML = "Copied: " + copyText.value;
}

function copyDiscountCodeMouseOut(tooltips) {
  var tooltip = document.getElementById(tooltips);
  tooltip.innerHTML = "Copy to clipboard";
}
$(document).ready(function () {
   $(document).on('change','.sellingplan_update', function() {
    
    var sellingplan = $(this).val();
    var productId = $(this).data("productid");
    var producthandle = $(this).data("producthandle");
    var variationId = $(this).data("id");
    var line = $(this).data("line");
    var quantity = $(this).data("quantity");
    if($(this).closest('.cart_subscribeRow').find("input[type=checkbox]:checked").length > 0){
       $('#allcartitems').addClass('added_loading');
       $.ajax({
        type: "POST",
        url: window.Shopify.routes.root+"cart/change.js",
        data:
          "quantity=" +
          quantity +
          "&line=" +
          line +
          "&selling_plan=" +
          sellingplan,
        dataType: "json",
        success: function (cart) {
          getcart();
          $('#allcartitems').removeClass('added_loading');
        },
      });
    }    
  });
  $(document).on('change','.update-subscription', function() {
    $('#allcartitems').addClass('added_loading');
    var productId = $(this).data("productid");
    var producthandle = $(this).data("producthandle");
    var variationId = $(this).data("id");
    var line = $(this).data("line");
    var date = new Date();
    var quantity = $(this).data("quantity");
    if (this.checked) {
      var sellingplan = $(this)
        .closest(".cart_subscribeRow")
        .find("select")
        .val();
      $.ajax({
        type: "POST",
        url: window.Shopify.routes.root+"cart/change.js",
        data:
          "quantity=" +
          quantity +
          "&line=" +
          line +
          "&selling_plan=" +
          sellingplan,
        dataType: "json",
        success: function (cart) {
          
           applypromos(cart);
         getcart();
          $('#allcartitems').removeClass('added_loading');
        },
      });
    } else {
      $.ajax({
        type: "POST",
        url: window.Shopify.routes.root+"cart/change.js",
        data: "quantity=" + quantity + "&line=" + line + "&selling_plan=",
        dataType: "json",
        success: function (cart) {
          
           applypromos(cart);
          getcart();
          $('#allcartitems').removeClass('added_loading');
        },
      });
    }
  });
});
// nav new script start
  // nav toggle
  const clickLazyImages = [].slice.call(document.querySelectorAll("img.on-opennav"));
  $(".navToggleBtn").click(function () {
    if ($(window).width() > 991) {
      $(".desktop_menu_wrapper").toggleClass("desktop_slide");
      $("html").toggleClass("showNav deskop_layer");
      $('.menuSearchWrap').removeClass('searchOpen');
      $('.searchBtnIcon').removeClass('active');
    } else {
      $(".desktop_menu_wrapper").addClass("desktop_slide");
      if (hiddenMenuItems.length === 0) {
        $(".cross_mobile_inj svg").css("opacity", "0");
      }
      $("html").addClass("showNav deskop_layer");
    }
    clickLazyImages.forEach(function (clickimg) {
       clickimg.src = clickimg.dataset.src;
       clickimg.srcset = clickimg.dataset.srcset;
       clickimg.classList.remove("on-opennav");
    });
  });
  let hiddenMenuItems = [];
  if ($(window).width() <= 992) {
    $(".drop_downmenu > a").on("click", function (e) {
      $(".cross_mobile_inj svg").css("opacity", "1");
      var $parentLi = $(this).closest(".drop_downmenu");
      //console.log();
      var $submenu = $parentLi.children(".sub_menuinner");
      var menuLink1 = $(this).attr("href");

      if (
        $submenu.length === 0 &&
        menuLink1 &&
        menuLink1 !== "javascript:void(0)"
      ) {
        window.location.href = menuLink1;
        return;
      }

      e.preventDefault();
      $parentLi.siblings("li").hide();
      $parentLi.children("a").hide();
      $submenu.addClass("show_dropdown");
      $(".sub_menuinner").not($submenu).removeClass("show_dropdown");
      var menuText = $(this).text().trim();
      hiddenMenuItems.push({
        element: $parentLi,
        submenu: $submenu,
        text: menuText,
      });
      //console.log("hiddenMenuItems", hiddenMenuItems);
      $("#title_heading").text(menuText);
    });

    $(".sub_menuinner > ul > li > a").on("click", function (e) {
      var $nestedParentLi = $(this).closest("li");
      var $nestedSubmenu = $nestedParentLi.children(".nested_inner");
      var menuLink = $(this).attr("href");

      if (
        $nestedSubmenu.length === 0 &&
        menuLink1 &&
        menuLink1 !== "javascript:void(0)"
      ) {
        window.location.href = menuLink1;
        return;
      }

      e.preventDefault();
      $nestedParentLi.siblings("li").hide();
      $nestedParentLi.children("a").hide();
      $nestedSubmenu.addClass("show_dropdown");
      $(".nested_inner").not($nestedSubmenu).removeClass("show_dropdown");
      var submenuText = $(this).text().trim();
      hiddenMenuItems.push({
        element: $nestedParentLi,
        submenu: $nestedSubmenu,
        text: submenuText,
      });
      $("#title_heading").text(submenuText);
      $(".cross_mobile_inj svg").css("opacity", "1");
    });

    $("#title_heading").click(function () {
      if (hiddenMenuItems.length > 0) {
        let lastItem = hiddenMenuItems.pop();
        lastItem.element.siblings("li").show();
        lastItem.element.show();
        lastItem.element.children("a").show();
        lastItem.submenu.removeClass("show_dropdown");
        let previousText =
          hiddenMenuItems.length > 0
            ? hiddenMenuItems[hiddenMenuItems.length - 1].text
            : "";
        $("#title_heading").text(previousText);
        if (!previousText) $(".cross_mobile_inj svg").css("opacity", "0");
      } else {
        $(".desktop_firstlevel > li").show();
        $(".sub_menuinner, .nested_inner").removeClass("show_dropdown");
        $(".cross_mobile_inj svg").css("opacity", "0");
      }
    });
    $(".cross_right_l").click(function () {
      $(".desktop_menu_wrapper").removeClass("desktop_slide");
      $("html").removeClass("showNav deskop_layer");
    });
  }
// end------------

function addmembership(buttonobj) {
  
  if (typeof(window.Tapcart) !== "undefined" && window.Tapcart.isInitialized) {
   window.Tapcart.actions.addToCart({
         lineItems: [{
            quantity: 1,
            variantId: '40400099803171',
            sellingPlanId: '2916188195',
            attributes: [
                    {
                        key: '_inveterate_subscription',
                        value: true,
                    },
              ],
            
        },{
            quantity: 1,
            variantId: '40524290949155',
            attributes: [
                    {
                        key: '_inveterate_free_signup_gift',
                        value: true,
                    },
              ],
        }],
  
    });
      window.Tapcart.actions.showToast({
        message: 'Product Successfully Added',
        type: "success", // "success" || "error"
      });
  }
  else{
buttonobj.disabled=true;
  buttonobj.innerHTML= 'ADDING...'
  
   let formData = {
 'items': [{
            "id": 40524290949155,
            "quantity": 1,
            "properties": {
                    "_inveterate_free_signup_gift": true
                }
            },
            {
                "id": 40400099803171,
                "quantity": 1,
                "selling_plan": 2916188195,
                "properties": {
                    "_inveterate_subscription": true
                }
            }]
};
fetch(window.Shopify.routes.root + 'cart/add.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify(formData)
})
.then(response => {
  return response.json();
})
  .then((json) => {
    buttonobj.innerHTML= 'IN CART'
    $.each(json, function (key, data) {
    $.each(data, function (index, data) {        
      if(data.id == 40400099803171){
        $(".sidebar__cartItem").html(
          '<a href="https://www.trulybeauty.com/products/' +
            data.handle +
            '"><div class="cartItem__img pb-1"><img src="' +
            data.image +
            '" alt="cart-product" class="d-block"></div><div class="cartItem__title">' +
            data.product_title +
            "</div></a>"
        );
      }
    });
      $.ajax({
    type: "GET",
    url: window.Shopify.routes.root+"cart.js",
    dataType: "json",
    success: function (cart) {
      if (cart.item_count === 0) {
        $(".special-offer--cartside").addClass("d-none");
        $(".headerCartItems").html("0");
      } else {
        $(".headerCartItems").html(Number(cart.item_count));
        $("#alreadyincart").addClass("d-none");
        $("#cartbestseller").removeClass("d-none");
        applypromos(cart);
        $("body").removeClass("showModal showAccountModal"),
        $("body").addClass("showModal showCartModal"),
        $(".trulySidebarModelOverlay").fadeIn(100),
        $(".cart_favorite_item_slider").resize()
        if ($("body").hasClass("template-cart")) {
        location.reload();
        }
      }
    },
  });
})  
    $('#memebership_join').prop('disabled', true).html('In Cart');
    $('.freeShippingProgress').addClass('ismember');
})
.catch((error) => {
  console.error('Error:', error);
});
}
}

function addmembershipfreeproduct() {
   let formData = {
 'items': [{
            "id": 40524290949155,
            "quantity": 1,
            "properties": {
                    "_inveterate_free_signup_gift": true
                }
            }]
};
fetch(window.Shopify.routes.root + 'cart/add.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify(formData)
})
.then(response => {
  return response.json();
})
  .then((json) => {
    $.ajax({
      type: "GET",
      url: window.Shopify.routes.root+"cart.js",
      dataType: "json",
      async: true,
        success: function (cart) {
          applypromos(cart);
          getcart();
        }
      });
})
.catch((error) => {
  console.error('Error:', error);
});
}
$(document).on("click",".know_more",function () {
            $(".know_more_cntnt").slideToggle(300);
        });
$(document).on(
  "change",
  ".product_variant_options input[type=radio][name=id]",
  function () {
    var shadetype = $('li.tab_links.active').data('tab');
    var producthandle = this.dataset.producthandle;
    var firstSlash = window.location.pathname.indexOf('/');
    var secondSlash = window.location.pathname.indexOf('/', firstSlash + 1);
    var thirdSlash = window.location.pathname.indexOf('/', secondSlash + 1);
    if (thirdSlash !== -1) { // Check if a third slash exists
        var pathname = window.location.pathname.substring(0, thirdSlash);
    } else {
        // Handle cases where there are fewer than 3 slashes
        var pathname = window.location.pathname;
    }
    
    if (window.location.pathname == '/products/luxury-peptide-lip-oil') {
      varainturl= window.location.protocol + '//' + window.location.hostname + window.location.pathname + '?variant='+this.value+'&type='+shadetype;
    }else if (typeof producthandle !== 'undefined') {
      varainturl= window.location.protocol + '//' + window.location.hostname + pathname +'/producthandle='+producthandle+'&variantid='+this.value;
    }else{
       varainturl= window.location.protocol + '//' + window.location.hostname + window.location.pathname + '?variant='+this.value;
    }

    window.location.replace(varainturl);
   // getvariationDetailResults($("input[name=producthandle]").val(), this.value);
  }
);

function getvariationDetailResults(producthandle, varientid) {
  fetch(
    `/products/${producthandle}?variant=${varientid}&section_id=variant-product-data`
  )
    .then((response) => {
      if (!response.ok) {
        var error = new Error(response.status);
        this.close();
        throw error;
      }

      return response.text();
    })
    .then((text) => {
      $(".productSliderNav").slick("unslick");
      $(".productSliderMain").slick("unslick");
      const resultsMarkup = new DOMParser()
        .parseFromString(text, "text/html")
        .querySelector("#howtouse").innerHTML;
      $(".product-howtouse-style").html(resultsMarkup);

      const resultsMarkup1 = new DOMParser()
        .parseFromString(text, "text/html")
        .querySelector("#whatittarget").innerHTML;
      $(".product-target-style").html(resultsMarkup1);

      const resultsMarkup2 = new DOMParser()
        .parseFromString(text, "text/html")
        .querySelector("#productSliderHolder").innerHTML;
      $(".productSliderHolder").html(resultsMarkup2);

      const resultsMarkup4 = new DOMParser()
        .parseFromString(text, "text/html")
        .querySelector("#subscribeandsave").innerHTML;
      $(".product-subscribe-save-style").html(resultsMarkup4);

      const resultsMarkup5 = new DOMParser()
        .parseFromString(text, "text/html")
        .querySelector("#product-detail").innerHTML;
      $(".productDetail").html(resultsMarkup5);

      const resultsMarkup6 = new DOMParser()
        .parseFromString(text, "text/html")
        .querySelector("#productmainreviews").innerHTML;
      $(".product-reviews-style").html(resultsMarkup6);

      StampedFn.reloadUGC();
      $(".productSliderNav").slick(prodNavSlider);
      $(".productSliderMain").slick(prodmainSlider);
    })
    .catch((error) => {
      throw error;
    });
}

$(document).on("click", ".selectedviewitem", function () {
  dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
dataLayer.push({
  event: "select_item",
  ecommerce: {
     item_list_id: $(this).data('prlist').toLowerCase().replace(/ /g,"_"),
     item_list_name: $(this).data('prlist'),
    items: [
    {
      item_id: $(this).data('prsku'),
      item_name: $(this).data('prtitle'),
      item_list_id: $(this).data('prlist').toLowerCase().replace(/ /g,"_"),
      item_list_name: $(this).data('prlist'),
      price: $(this).data('prprice')
    }
    ]
  }
});

});
function slickSliderActiveSlide(isSlide) {
  let a = document.querySelectorAll(".into_product.active .slick-slide.slick-active");
  let c = document.querySelectorAll(".into_product.active .slick-slide.slick-current");
  if(isSlide == 'next'){
    var currentsl = a[a.length - 1];
    var sam = currentsl.querySelectorAll(".into_product-slide");
    //console.log("slickSlider",sam[0].dataset.prtitle);
        dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
        dataLayer.push({
          event: "view_item",
          ecommerce: {
             currency: "USD",
            items: [
            {
              item_id: sam[0].dataset.prsku,
              item_name: sam[0].dataset.prtitle,
              item_list_id: sam[0].dataset.prlist.toLowerCase().replace(/ /g,"_"),
              item_list_name: sam[0].dataset.prlist,
              price: sam[0].dataset.prprice
            }
            ]
          }
        });
  }else if(isSlide == 'prev'){
    var sam = c[0].querySelectorAll(".into_product-slide");
    //console.log("slickSlider",sam[0].dataset.prtitle);
        dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
        dataLayer.push({
          event: "view_item",
          ecommerce: {
             currency: "USD",
            items: [
            {
              item_id: sam[0].dataset.prsku,
              item_name: sam[0].dataset.prtitle,
              item_list_id: sam[0].dataset.prlist.toLowerCase().replace(/ /g,"_"),
              item_list_name: sam[0].dataset.prlist,
              price: sam[0].dataset.prprice
            }
            ]
          }
        });
  }else{
    a.forEach((b) => {
      var sam = b.querySelectorAll(".into_product-slide");
      //console.log("slickSlider",sam[0].dataset.prtitle);
        dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
        dataLayer.push({
          event: "view_item",
          ecommerce: {
             currency: "USD",
            items: [
            {
              item_id: sam[0].dataset.prsku,
              item_name: sam[0].dataset.prtitle,
              item_list_id: sam[0].dataset.prlist.toLowerCase().replace(/ /g,"_"),
              item_list_name: sam[0].dataset.prlist,
              price: sam[0].dataset.prprice
            }
            ]
          }
        });
    });
  }
    
  
}
function swiperSliderActiveSlide(id,isSlide) {
  let a = document.querySelectorAll(".into_product_slider2 .into_product-slide.swiper-slide");
  let ct = document.querySelectorAll(`.into_product_slider2 .into_product-slide.swiper-slide[data-id="${id}"]`);
  let arr = [];  
  for (let i = 0; i < a.length; i++) {
    if (a[i].classList.contains("swiper-slide-active")) {
      if(id){
        arr.push(ct[i]);arr.push(ct[i + 1]);arr.push(ct[i + 2]);
      }else{
        arr.push(a[i]);arr.push(a[i + 1]);arr.push(a[i + 2]);
      }  
    }
  }
  if(arr){
    if(isSlide == 'next'){
      var currentsl = arr[arr.length - 1];
      var sam = currentsl.querySelectorAll(".into_product_item");
      //console.log("swiperSlider",sam[0].dataset.prtitle);
      dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
        dataLayer.push({
          event: "view_item",
          ecommerce: {
             currency: "USD",
            items: [
            {
              item_id: sam[0].dataset.prsku,
              item_name: sam[0].dataset.prtitle,
              item_list_id: sam[0].dataset.prlist.toLowerCase().replace(/ /g,"_"),
              item_list_name: sam[0].dataset.prlist,
              price: sam[0].dataset.prprice
            }
            ]
          }
        });
    }else if(isSlide == 'prev'){
      var currentsl = arr[0];
      var sam = currentsl.querySelectorAll(".into_product_item");
      //console.log("swiperSlider",sam[0].dataset.prtitle);
      dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
        dataLayer.push({
          event: "view_item",
          ecommerce: {
             currency: "USD",
            items: [
            {
              item_id: sam[0].dataset.prsku,
              item_name: sam[0].dataset.prtitle,
              item_list_id: sam[0].dataset.prlist.toLowerCase().replace(/ /g,"_"),
              item_list_name: sam[0].dataset.prlist,
              price: sam[0].dataset.prprice
            }
            ]
          }
        });
    }else{
      arr.forEach((b) => {
      var sam = b.querySelectorAll(".into_product_item");
      //console.log("swiperSlider",sam[0].dataset.prtitle);
        dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
        dataLayer.push({
          event: "view_item",
          ecommerce: {
             currency: "USD",
            items: [
            {
              item_id: sam[0].dataset.prsku,
              item_name: sam[0].dataset.prtitle,
              item_list_id: sam[0].dataset.prlist.toLowerCase().replace(/ /g,"_"),
              item_list_name: sam[0].dataset.prlist,
              price: sam[0].dataset.prprice
            }
            ]
          }
        });
      });
    }
    
  }
  
}
$(document).ready(function () {
  if ($("body").hasClass("template-index")) {
  slickSliderActiveSlide("");
  swiperSliderActiveSlide("","");
   $(document).on('click','.home_tabs li', function(){
     slickSliderActiveSlide("");
   });
  // $(document).on('click','.tab_link_ul li', function(){
  //   let tabId = this.getAttribute("data-tab");
  //   swiperSliderActiveSlide(tabId,"");
  //  });
  $(document).on('click','.slick-next', function(){
    slickSliderActiveSlide('next');
  });
  $(document).on('click','.swiper-button-next', function(){
    let tabId = document.querySelector(".tab_link_ul li.active")
    if (tabId) {
       swiperSliderActiveSlide(tabId.getAttribute("data-tab"),"next");
    }else{
       swiperSliderActiveSlide("","next");
    }
  });
  $(document).on('click','.slick-prev', function(){    
    slickSliderActiveSlide('prev');
  });
  $(document).on('click','.swiper-button-prev', function(){
    let tabId = document.querySelector(".tab_link_ul li.active")
    if (tabId) {
       swiperSliderActiveSlide(tabId.getAttribute("data-tab"),"prev");
    }else{
       swiperSliderActiveSlide("","prev");
    }
  });
}
});

/* Custom Back in Stock Form klaviyo*/
$("form#cbssubscribeform").submit(function () {
  email = $("#cbssubscribe-email");
  if (
    !/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(
      email.val()
    )
  ) {
    email.addClass("needsfilled");
    email.val("Enter valid email address");
  }
  if ($(":input").hasClass("needsfilled")) {
    return false;
  } else {
    $("button#cbinbsubscribe").css("pointer-events", "none");
    var cbsuseremail = $("#cbssubscribe-email").val();
    var cbsproductname = $("#cbsproductname").val();
    var cbsproductid = $("#cbsproductid").val();
    var cbsproductvariantid = $("#cbsproductvariantid").val();
    var cbsproductsku = $("#cbsproductsku").val();
    var cbsproducturl = $("#cbsproducturl").val();
    $.ajax({
      url: "https://mytrulydeals.com/trulybeauty/product-back-instock.php",
      type: "POST",
      data: {
        ajaxaction: "subscribebslist",
        subemailaddress: cbsuseremail,
        cbsproductname: cbsproductname,
        cbsproductid: cbsproductid,
        cbsproductvariantid: cbsproductvariantid,
        cbsproductsku: cbsproductsku,
        cbsproducturl: cbsproducturl,
      },
      async: true,
      success: function (response) {
        //console.log(response);
        $("form#cbssubscribeform").get(0).reset();
        $("#cbssubscribe-email").val("");
        alert("Thank you for subscribing.");
        $("button#cbinbsubscribe").css("pointer-events", "auto");
      },
      timeout: 5000000, // sets timeout to 5 seconds
    });

    return false;
  }
});

if ($("body").hasClass("template-index")) {
  document.addEventListener("DOMContentLoaded", function () {
   var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutationRecord) {                 
      let allnsta = document.querySelectorAll('.instafeed-hover-layer'); 
        for (let i = 0; i < allnsta.length; i++) {
          itemid = i+1;
          allnsta[i].classList.add("hm-instafeed-hover-layer-"+ itemid);
        } 
        observer.disconnect();
      });    
    });
    var target = document.getElementById("insta-feed");
    observer.observe(target, {
      childList: true,     // detects node additions/removals
      subtree: true,       // observes nested children
      characterData: true  // detects text content changes
    });
  });
}
if ($("body").hasClass("template-product") || $("body").hasClass("template-truly-subscription-box")) {
  document.addEventListener("DOMContentLoaded", function () {
   var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutationRecord) {                 
      let allnsta = document.querySelectorAll('.stamped-review-header-title'); 
        for (let i = 0; i < allnsta.length; i++) {
          itemid = i+1;
          if(allnsta[i].innerHTML === ''){
          allnsta[i].remove();  
          }
          
        } 
        observer.disconnect();
      });    
    });
    var target = document.getElementById("stamped-main-widget");
    observer.observe(target, {
      childList: true,     // detects node additions/removals
      subtree: true,       // observes nested children
      characterData: true  // detects text content changes
    });
  });
}
if ($("body").hasClass("template-data-sharing-opt-out")) {
  document.addEventListener("DOMContentLoaded", function () {
   var observer = new MutationObserver(function(mutations) {
     mutations.forEach(function(mutationRecord) {                 
      $('#pc--show-email-field').prop('checked', true);
      $("#pc--browser-opt-out-checkbox").attr("aria-label", "Opt Out");
      $('textarea[name="h-captcha-response"]').attr("aria-label", "Captcha Response");
      $('textarea[name="g-recaptcha-response"]').attr("aria-label", "Captcha Response");
      
       $('#pc--opt-out-form-field-email').show();
        observer.disconnect();  
      });
     
       
    });
    var target = document.getElementById("pc--optOutFormContainer");
    observer.observe(target, {
      childList: true,     // detects node additions/removals
      subtree: true,       // observes nested children
      characterData: true  // detects text content changes
    });
  });
}

if(typeof customer_id != "undefined" && getCookie("istrulyplusmember") == "yes"){
  setTimeout(function() { 
    var checkuserlogin = getCookie("logState");
    //console.log("checkuserlogin", checkuserlogin);
    if(checkuserlogin == 'firstLog'){
      $.ajax({
        type: "GET",
        url: window.Shopify.routes.root+"cart.js",
        dataType: "json",
        async: false,
        success: function (cart) {
          if (cart.item_count >= 1) {  
            var trulyplusincart = 0;
            cart.items.forEach(function (item, index) {
              if(item.variant_id == 40400099803171){
                trulyplusincart = 1;
              }
            }); 
            if(trulyplusincart == 1){
               rmproducts = {};
               rmproducts[40400099803171]=0;
               rmproducts[40524290949155]=0;
               $.ajax({
                 type: "POST",
                 url: window.Shopify.routes.root+"cart/update.js",
                 data: { updates: rmproducts },
                 dataType: "json",
                 async:false,
                 success: function (data) {
                  location.reload();
                 },
              });
            }else{
                location.reload();
            }
          }
        }
      });
    }
  }, 1000);
}

 $(document).on("click", ".byd_quickview", function () {
    var producthandle = $(this).attr("data-producthandle");
    var variantid = $(this).attr("data-variantid");
    if (typeof variantid !== 'undefined') {
      var fetchurl = `/products/${producthandle}?variant=${variantid}&section_id=byd-productview`
    }else{
      var fetchurl = `/products/${producthandle}?section_id=byd-productview`;
    }
    fetch(fetchurl)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        $(".productSliderNav").slick("unslick");
        $(".productSliderMain").slick("unslick");
        $("#quickviewresponse").html(text);
        StampedFn.reloadUGC();
        $(".productSliderNav").slick(prodNavSlider);
        $(".productSliderMain").slick(prodmainSlider);
      })
      .catch((error) => {
        throw error;
      });
  });
if ($("body").hasClass("template-product")) {
const currentUrl = window.location.href;
const searchReviewString = "#review-single";
if (currentUrl.includes(searchReviewString)) {
    document.addEventListener('stamped:reviews:loaded', stampedwritereview);
  function stampedwritereview(){
    StampedFn.toggleForm('review');
  }
}  
}


// remove cart items if main removed (Diamond Bundlebox).
// remove old items ajax
  function removeOldItems(keys) {
  var updates = {};
  keys.forEach(function(key) {
      updates[key] = 0; // set lineitme value to zero
  });
  $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: { updates: updates },
      dataType: 'json',
      success: function() {
        console.log('Old Items are removed');
        window.location.replace("/pages/diamond-baby-limited-time-offer");
      },
      error: function(err) {
          $('#atc_bundle').addClass('disabled');
          console.error('Error removing items:', err);
      }
  });
  }
// remove old itmes ends
// Change the cart according to requirementes 
  function CartChagne(){
    $.getJSON('/cart.js', function(cart) {
      var itemsToRemove = [];
      cart.items.forEach(function(item) {
          // Find items by property
          console.log(item.properties.Role);
          if (item.properties._free_with === "Diamond Baby Body Serum" || item.properties._freeShippingProductOffer === "diamondBabySerum") {
                itemsToRemove.push(item.key); // push to array item.key
          }
      });
      if (itemsToRemove.length) {
          console.log(itemsToRemove);
          removeOldItems(itemsToRemove);
      }
    });
  }
// atc_bundle buttno clicked  
 $(document).on('click', '.remove_diamond', function (e) {
   e.preventDefault();
   $(this).addClass('disabled');
   CartChagne();
 });

